<template>
  <div id="insightsTeam">
    <div class="margin-subpages">
      <div class="flex space-between items-start">
        <el-select
          v-model="selectTeam"
          filterable
          placeholder="Select"
          class="input-style"
          :class="[ blurMode ?  'blurelement': '' ]"
          @change="changMainPageData"
        >
          <el-option
            v-if="user.user_type !== 'leadership'"
            class="text-dropdown"
            key="all"
            :label="`All Teams (${$utils(
              'addCommasInNumber',
              optionsTeam.length
            )})`"
            value="all"
          ></el-option>
          <el-option
            class="text-dropdown"
            :class="[ blurMode ?  'blurelement': '' ]"
            v-for="item in optionsTeam"
            :key="item.key"
            :label="item.name"
            :value="item.key"
          ></el-option>
        </el-select>

        <div class="flex items-center ml-32">
          <div class="pr-12 mt-11">
            <span class="fc-4A4A4A">{{ $t("insights.Duration") }}</span>
          </div>
          <div class="showOption">
            <el-menu
              class="el-menu-demo menuOptionStyle"
              mode="horizontal"
              style="width: 200px"
            >
              <el-submenu index="0" style="width: 200px">
                <template slot="title">
                  <span class="txtOption2">{{ selectMainPageMonth }}</span>
                </template>
                <el-menu-item
                  index="1"
                  @click="handleMainPageMonth('30-days')"
                  class="is-active"
                  style="font-size: 16px; width: 200px"
                  >{{ $t("insights.Last_30_days") }}</el-menu-item
                >
                <el-menu-item
                  index="2"
                  @click="handleMainPageMonth('60-days')"
                  class="is-active"
                  style="font-size: 16px; width: 200px"
                  >{{ $t("insights.Last_60_days") }}</el-menu-item
                >
                <el-menu-item
                  index="3"
                  @click="handleMainPageMonth('13-weeks')"
                  class="is-active"
                  style="font-size: 16px; width: 200px"
                  >{{ $t("insights.Last_13_weeks") }}</el-menu-item
                >
                <el-menu-item
                  index="4"
                  @click="handleMainPageMonth('26-weeks')"
                  class="is-active"
                  style="font-size: 16px; width: 200px"
                  >{{ $t("insights.Last_26_weeks") }}</el-menu-item
                >
                <el-menu-item
                  index="5"
                  @click="handleMainPageMonth('52-weeks')"
                  class="is-active"
                  style="font-size: 16px; width: 200px"
                  >{{ $t("insights.Last_52_weeks") }}</el-menu-item
                >
                <el-menu-item
                  index="6"
                  @click="handleMainPageMonth('24-months')"
                  class="is-active"
                  style="font-size: 16px; width: 200px"
                  >{{ $t("insights.Last_24_months") }}</el-menu-item
                >
              </el-submenu>
            </el-menu>
          </div>
        </div>
      </div>

      <!-- Team Health Overview -->
      <div class="fs-15 fw-700 mt-24">Team Health Overview</div>
      <div class="flex-center">
        <div class="box-card-border highlights mt-12 mb-24">
          <div class="grid-5-20">
            <!-- Happiness Score -->
            <div class="flex-column mr-24 health-metric-container" @mouseenter="showTooltip('happiness', $event)" @mouseleave="hideTooltip">
              <div class="fs-12 fw-700 mb-12">Happiness</div>
              <div class="grid-5-20" v-if="loadingMainData">
                <div class="text-skeleton"></div>
              </div>
              <div v-else class="flex-column">
                <div class="flex-row items-center mb-8">
                  <div class="fs-24 fw-500">{{ teamMetrics.happinessScore || '-' }}{{ teamMetrics.happinessScore ? '%' : '' }}</div>
                  <div v-if="teamMetrics.happinessTrend !== null" class="fs-12 fw-500 ml-8" :style="{ color: teamMetrics.happinessTrend > 0 ? '#1AC362' : (teamMetrics.happinessTrend < 0 ? '#F44336' : '#6A6A6A') }">
                    {{ teamMetrics.happinessTrend >= 0 ? '+' : '' }}{{ teamMetrics.happinessTrend }} pts
                  </div>
                </div>
                <div v-if="!loadingMainData" class="health-progress-bar"
                     @mouseenter="showTooltip('happiness', $event)"
                     @mouseleave="hideTooltip">
                  <div class="health-progress-fill" :style="getProgressBarStyle('happiness', teamMetrics.happinessScore)"></div>
                </div>
                <div v-else class="health-progress-skeleton"></div>
              </div>
            </div>

            <!-- Risk Score -->
            <div class="flex-column mr-24 health-metric-container" @mouseenter="showTooltip('risk', $event)" @mouseleave="hideTooltip">
              <div class="fs-12 fw-700 mb-12">Risk Level</div>
              <div class="grid-5-20" v-if="loadingMainData">
                <div class="text-skeleton"></div>
              </div>
              <div v-else class="flex-column">
                <div class="flex-row items-center mb-8">
                  <div class="fs-24 fw-500">{{ teamMetrics.riskScore === null || teamMetrics.riskScore === undefined ? '-' : teamMetrics.riskScore }}{{ teamMetrics.riskScore === null || teamMetrics.riskScore === undefined ? '' : '%' }}</div>
                  <div v-if="teamMetrics.riskTrend !== null" class="fs-12 fw-500 ml-8" :style="{ color: teamMetrics.riskTrend < 0 ? '#1AC362' : (teamMetrics.riskTrend > 0 ? '#F44336' : '#6A6A6A') }">
                    {{ teamMetrics.riskTrend >= 0 ? '+' : '' }}{{ teamMetrics.riskTrend }} pts
                  </div>
                </div>
                <div v-if="!loadingMainData" class="health-progress-bar"
                     @mouseenter="showTooltip('risk', $event)"
                     @mouseleave="hideTooltip">
                  <div class="health-progress-fill" :style="getProgressBarStyle('risk', teamMetrics.riskScore)"></div>
                </div>
                <div v-else class="health-progress-skeleton"></div>
              </div>
            </div>

            <!-- Active Users -->
            <div class="flex-column mr-24 health-metric-container" @mouseenter="showTooltip('activeUsers', $event)" @mouseleave="hideTooltip">
              <div class="fs-12 fw-700 mb-12">Weekly Active Users</div>
              <div class="grid-5-20" v-if="loadingMainData">
                <div class="text-skeleton"></div>
              </div>
              <div v-else class="flex-column">
                <div class="flex-row items-center mb-8">
                  <div class="fs-24 fw-500">{{ teamMetrics.activeUserRate || '-' }}{{ teamMetrics.activeUserRate ? '%' : '' }}</div>
                  <div v-if="teamMetrics.activeUserTrend !== null" class="fs-12 fw-500 ml-8" :style="{ color: teamMetrics.activeUserTrend > 0 ? '#1AC362' : (teamMetrics.activeUserTrend < 0 ? '#F44336' : '#6A6A6A') }">
                    {{ teamMetrics.activeUserTrend >= 0 ? '+' : '' }}{{ teamMetrics.activeUserTrend }} pts
                  </div>
                </div>
                <div v-if="!loadingMainData" class="health-progress-bar"
                     @mouseenter="showTooltip('activeUsers', $event)"
                     @mouseleave="hideTooltip">
                  <div class="health-progress-fill" :style="getProgressBarStyle('activeUsers', teamMetrics.activeUserRate)"></div>
                </div>
                <div v-else class="health-progress-skeleton"></div>
              </div>
            </div>

            <!-- DEBI Score -->
            <div class="flex-column mr-24 health-metric-container" @mouseenter="showTooltip('debi', $event)" @mouseleave="hideTooltip">
              <div class="fs-12 fw-700 mb-12">Engagement (DEBI)</div>
              <div class="grid-5-20" v-if="loadingMainData">
                <div class="text-skeleton"></div>
              </div>
              <div v-else class="flex-column">
                <div class="fs-24 fw-500 mb-8">{{ teamMetrics.debiScore || '-' }}</div>
                <div v-if="!loadingMainData" class="health-progress-bar"
                     @mouseenter="showTooltip('debi', $event)"
                     @mouseleave="hideTooltip">
                  <div class="health-progress-fill" :style="getProgressBarStyle('debi', teamMetrics.debiScore)"></div>
                </div>
                <div v-else class="health-progress-skeleton"></div>
              </div>
            </div>

            <!-- Retention Rate -->
            <div class="flex-column mr-24 health-metric-container" @mouseenter="showTooltip('retention', $event)" @mouseleave="hideTooltip">
              <div class="fs-12 fw-700 mb-12">6-mo Retention</div>
              <div class="grid-5-20" v-if="loadingMainData">
                <div class="text-skeleton"></div>
              </div>
              <div v-else class="flex-column">
                <div class="fs-24 fw-500 mb-8">{{ teamMetrics.retentionRate || '-' }}{{ teamMetrics.retentionRate ? '%' : '' }}</div>
                <div v-if="!loadingMainData" class="health-progress-bar"
                     @mouseenter="showTooltip('retention', $event)"
                     @mouseleave="hideTooltip">
                  <div class="health-progress-fill" :style="getProgressBarStyle('retention', teamMetrics.retentionRate)"></div>
                </div>
                <div v-else class="health-progress-skeleton"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tooltip for health metrics -->
      <div
        v-if="tooltipVisible"
        class="health-tooltip"
        :style="tooltipStyle"
        v-html="tooltipContent">
      </div>


      <div class="headerCard">
        <div class="flex-1 mt-10">
          <span class="txtHeaderCard">{{
            $t("insights.HAPPINESS_VS_RISK_RATE")
          }}</span>
        </div>
        <div class="pl-10">
          <svg
            @click="exportChart('mainPage')"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            class="icon-export"
          >
            <path
              fill="currentColor"
              d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z"
            />
          </svg>
        </div>
      </div>
      <div class="chart-bar relative" style="height: 217px">
        <div class="loading-chart-bar flex-mid pt-1" v-if="loadingData">
          <loading-even></loading-even>
        </div>
        <div class="flex-mid" v-else>
          <div class="chart-type-bar green ml-16"></div>
          <div class="type-bar-text">{{ $t("insights.HAPPINESS") }}</div>
          <div class="chart-type-bar red"></div>
          <div class="type-bar-text">{{ $t("insights.RISK") }}</div>
          <div class="chart-type-bar line">
            <div></div>
          </div>
          <div class="type-bar-text">{{ $t("insights.ACTIVE_USERS") }}</div>
        </div>
        <div
          v-if="loadingData"
          class="absolute-mid"
          style="height: 197px; width: 100%"
        >
          <img
            class="absolute-mid"
            src="@/assets/images/insights/bar_chart_empty_state.png"
          />
        </div>
        <div
          v-else-if="!loadingData && Object.keys(this.datachart).length == 0"
          class="absolute-mid"
          style="height: 197px; width: 100%"
        >
          <img
            class="absolute-mid"
            src="@/assets/images/insights/bar_chart_empty_state.png"
          />
          <div class="absolute-mid center fs-12 fw-500" style="width: 100%">
            {{ $t("insights.There_is_no_happiness") }}
          </div>
        </div>
        <div style="height: 180px">
          <canvas ref="chartCurrent"></canvas>
        </div>
      </div>
      <div class="flex mt-26">
        <span class="txtHeaderCard">{{ $t("insights.SPOTLIGHT") }}</span>
      </div>
      <div class="flex" style="flex-direction: row">
        <div class="SpotBox mr-16">
          <div class="flex-between">
            <div>
              <span class="txt-spot-card">{{
                $t("insights.Most_Engaged")
              }}</span>
            </div>
            <el-tooltip effect="dark" placement="top">
              <div class="tooltipStyle" slot="content">
                {{ $t("insights.Teams_with_highest_engagement") }}
              </div>
              <div class="flex-center">
                <img :src="getImgUrl('help_outline-16px')" />
              </div>
            </el-tooltip>
          </div>
          <div v-if="mostengageMain.length == 0" style="padding-top: 14px">
            <span class="noDataTextStyle">{{
              $t("insights.No_most_engaged_at")
            }}</span>
          </div>
          <div v-if="mostengageMain.length > 0" v-for="item in mostengageMain" :key="`MP-1-${item.no}`">
            <div class="SpotGroupBox"
            :class="[ blurMode ?  'blurelement': '' ]" @click="showModal(item.teamid)">
              <div class="flex-between">
                <div
                  style="overflow: hidden; padding-left: 12px; padding-top: 8px"
                >
                  <div>
                    <span class="txtHeaderSpot">{{
                      truncateText(item.team, 20)
                    }}</span>
                  </div>
                  <div style="margin-top: -4px">
                    <span class="txtDetailSpot">{{
                      item.team_name ? truncateText(item.team_name, 23) : "Top Most"
                    }}</span>
                  </div>
                </div>
                <div class="flex-center my-14 mr-12 ml-5">
                  <img class="icon-anim" :src="getImgUrl('nav_next_24px')" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="SpotBox mr-16">
          <div class="flex-between">
            <div>
              <span class="txt-spot-card">{{
                $t("insights.Retention_Risks")
              }}</span>
            </div>
            <el-tooltip effect="dark" placement="top">
              <div class="tooltipStyle" slot="content">
                {{ $t("insights.Teams_with_highest_retention") }}
              </div>
              <div class="flex-center">
                <img :src="getImgUrl('help_outline-16px')" />
              </div>
            </el-tooltip>
          </div>
          <div v-if="retentionrisksMain.length == 0" style="padding-top: 14px">
            <span class="noDataTextStyle">{{
              $t("insights.No_retention_risks_at")
            }}</span>
          </div>
          <div
            v-if="retentionrisksMain.length > 0"
            v-for="item in retentionrisksMain"
            :key="`MP-2-${item.no}`"
          >
            <div class="SpotGroupBox" 
            :class="[ blurMode ?  'blurelement': '' ]" @click="showModal(item.teamid)">
              <div class="flex-between">
                <div
                  style="overflow: hidden; padding-left: 12px; padding-top: 8px"
                >
                  <div>
                    <span class="txtHeaderSpot">{{
                      truncateText(item.team, 20)
                    }}</span>
                  </div>
                  <div style="margin-top: -4px">
                    <span class="txtDetailSpot">{{
                      truncateText(item.team_name, 23)
                    }}</span>
                  </div>
                </div>
                <div class="flex-center my-14 mr-12 ml-5">
                  <img class="icon-anim" :src="getImgUrl('nav_next_24px')" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="SpotBox mr-16">
          <div class="flex-between">
            <div>
              <span class="txt-spot-card">{{
                $t("insights.Most_Improved")
              }}</span>
            </div>
            <el-tooltip effect="dark" placement="top">
              <div class="tooltipStyle" slot="content">
                {{ $t("insights.Teams_that_show_the_most") }}
              </div>
              <div class="flex-center">
                <img :src="getImgUrl('help_outline-16px')" />
              </div>
            </el-tooltip>
          </div>
          <div v-if="mostimproveMain.length == 0" style="padding-top: 14px">
            <span class="noDataTextStyle">{{
              $t("insights.No_most_improved_at")
            }}</span>
          </div>
          <div v-if="mostimproveMain.length > 0" v-for="item in mostimproveMain" :key="`MP-3-${item.no}`">
            <div class="SpotGroupBox" 
            :class="[ blurMode ?  'blurelement': '' ]" @click="showModal(item.teamid)">
              <div class="flex-between">
                <div
                  style="overflow: hidden; padding-left: 12px; padding-top: 8px"
                >
                  <div>
                    <span class="txtHeaderSpot">{{
                      truncateText(item.team, 20)
                    }}</span>
                  </div>
                  <div style="margin-top: -4px">
                    <span class="txtDetailSpot">{{
                      truncateText(item.team_name, 23)
                    }}</span>
                  </div>
                </div>
                <div class="flex-center my-14 mr-12 ml-5">
                  <img class="icon-anim" :src="getImgUrl('nav_next_24px')" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="SpotBox">
          <div class="flex-between">
            <div>
              <span class="txt-spot-card">{{
                $t("insights.Most_Critical")
              }}</span>
            </div>
            <el-tooltip effect="dark" placement="top">
              <div class="tooltipStyle" slot="content">
                {{ $t("insights.Teams_that_are_most_critical") }}
              </div>
              <div class="flex-center">
                <img :src="getImgUrl('help_outline-16px')" />
              </div>
            </el-tooltip>
          </div>
          <div v-if="mostcriticalMain.length == 0" style="padding-top: 14px">
            <span class="noDataTextStyle">{{
              $t("insights.No_most_critical")
            }}</span>
          </div>
          <div v-if="mostcriticalMain.length > 0" v-for="item in mostcriticalMain" :key="`MP-4-${item.no}`">
            <div class="SpotGroupBox" 
            :class="[ blurMode ?  'blurelement': '' ]" @click="showModal(item.teamid)">
              <div class="flex-between">
                <div
                  style="overflow: hidden; padding-left: 12px; padding-top: 8px"
                >
                  <div>
                    <span class="txtHeaderSpot">{{
                      truncateText(item.team, 20)
                    }}</span>
                  </div>
                  <div style="margin-top: -4px">
                    <span class="txtDetailSpot">{{
                      truncateText(item.team_name, 23)
                    }}</span>
                  </div>
                </div>
                <div class="flex-center my-14 mr-12 ml-5">
                  <img class="icon-anim" :src="getImgUrl('nav_next_24px')" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="headerCard2">
        <div class="flex-1 mt-10">
          <span class="txtHeaderCard">{{ $t("insights.TEAM_STATUS") }}</span>
        </div>
        <div style="padding-right: 12px; margin-top: 10px">
          <span class="fc-4A4A4A">{{ $t("insights.Sort_by") }}</span>
        </div>
        <div class="showOption">
          <el-menu
            class="el-menu-demo menuOptionStyle"
            mode="horizontal"
            style="width: 200px"
          >
            <el-submenu :index="`${selectMainPageSort}`" style="width: 200px">
              <template slot="title">
                <span class="txtOption2">{{
                  optionsSort[selectMainPageSort]
                }}</span>
              </template>
              <el-menu-item
                v-for="(value, key) in optionsSort"
                :key="`MAIN_PAGE-${key}`"
                :index="`${key}`"
                @click="sortByMainPage"
                style="font-size: 16px; width: 200px"
                >{{ value }}</el-menu-item
              >
            </el-submenu>
          </el-menu>
        </div>
      </div>
      <div class="divTable" style="min-height: 300px">
        <div v-if="loadingDataListTable || (realDataMainTreeTable.length === 0 && !mainTableDataReady)" class="center mt-20 mb-40 pt-20 pb-40">
          <loading-even></loading-even>
        </div>
        <el-table
          v-show="!loadingDataListTable && (realDataMainTreeTable.length > 0 || mainTableDataReady)"
          id="teamsTable"
          :data="realDataMainTreeTable"
          max-height="720"
          :empty-text="'There is no data to display for the current time period.'"
          ref="mainTeamsTable"
          style="width: 100%"
          :cell-style="cellStyle"
          row-key="id"
          lazy
          :expand-row-keys="mainExpandKeys"
          :load="load"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        >
          <el-table-column
            :remote="remoteMainPage"
            label-class-name="labelTeamTable"
            class-name="cell-with-nowrap"
            :label="$t('insights.Team')"
          >
            <template slot-scope="scope">
                <span
                  class="text-open-modal"
                  :class="[ blurMode ?  'blurelement': '' ]"
                  @click="showModal(scope.row.id)"
                  >{{ scope.row.team }}</span
                >
            </template>
          </el-table-column>
          <!-- :label="$t('insights.Happi_Rate')" -->
          <el-table-column
            label="Happiness Rate"
            width="80"
            label-class-name="labelRateTable"
            class-name="line-break"
            align="right"
          >
          <template slot="header">
              <el-tooltip content="The rate of &quot;Very Happy&quot; or &quot;Pretty Good&quot; responses to the &quot;How do you feel today?&quot; daily pulse question" placement="top">
                <span>Happiness Rate</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">{{
              `${scope.row.happirate}%`
            }}</template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Risk_Rate')"
            width="58"
            align="right"
            label-class-name="labelRateTable"
            class-name="line-break"
          >
          <template slot="header">
              <el-tooltip content="The rate of &quot;Not Great&quot; or &quot;Terrible&quot; responses to the &quot;How do you feel today?&quot; daily pulse question" placement="top">
                <span>Risk Rate</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">{{
              `${scope.row.riskrate}%`
            }}</template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Feedback')"
            label-class-name="labelTable"
            :render-header="renderPhaseHeader"
            width="38"
          >
            <template slot-scope="scope">
              <div class="flexCenter">
                <div
                  class="divCurcleStatus"
                  :class="scope.row.feedback.color"
                ><span class="fs-10 fw-700 scorelabel">{{ scope.row.feedback.score === 0 && scope.row.feedback.color === '#C7C7C7' ? '?' : Math.round(scope.row.feedback.score) }}</span></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Wellness')"
            label-class-name="labelTable"
            :render-header="renderPhaseHeader"
            width="38"
          >
            <template slot-scope="scope">
              <div class="flexCenter">
                <div
                  class="divCurcleStatus"
                  :class="scope.row.wellness.color"
                ><span class="fs-10 fw-700 scorelabel">{{ scope.row.wellness.score === 0 && scope.row.wellness.color === '#C7C7C7' ? '?' : Math.round(scope.row.wellness.score) }}</span></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Rel_Manager')"
            label-class-name="labelTable"
            :render-header="renderPhaseHeader"
            width="38"
          >
            <template slot-scope="scope">
              <div class="flexCenter">
                <div
                  class="divCurcleStatus"
                  :class="scope.row.manager.color"
                ><span class="fs-10 fw-700 scorelabel">{{ scope.row.manager.score === 0 && scope.row.manager.color === '#C7C7C7' ? '?' : Math.round(scope.row.manager.score) }}</span></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Recognition')"
            label-class-name="labelTable"
            :render-header="renderPhaseHeader"
            width="46"
          >
            <template slot-scope="scope">
              <div class="flexCenter">
                <div
                  class="divCurcleStatus"
                  :class="scope.row.recognition.color"
                ><span class="fs-10 fw-700 scorelabel">{{ scope.row.recognition.score === 0 && scope.row.recognition.color === '#C7C7C7' ? '?' : Math.round(scope.row.recognition.score) }}</span></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Ambassadorship')"
            label-class-name="labelTable"
            :render-header="renderPhaseHeader"
            width="38"
          >
            <template slot-scope="scope">
              <div class="flexCenter">
                <div
                  class="divCurcleStatus"
                  :class="scope.row.ambassadorship.color"
                ><span class="fs-10 fw-700 scorelabel">{{ scope.row.ambassadorship.score === 0 && scope.row.ambassadorship.color === '#C7C7C7' ? '?' : Math.round(scope.row.ambassadorship.score) }}</span></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Rel_Colleagues')"
            label-class-name="labelTable"
            :render-header="renderPhaseHeader"
            width="38"
          >
            <template slot-scope="scope">
              <div class="flexCenter">
                <div
                  class="divCurcleStatus"
                  :class="scope.row.colleagues.color"
                ><span class="fs-10 fw-700 scorelabel">{{ scope.row.colleagues.score === 0 && scope.row.colleagues.color === '#C7C7C7' ? '?' : Math.round(scope.row.colleagues.score) }}</span></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Personal_Growth')"
            label-class-name="labelTable"
            :render-header="renderPhaseHeader"
            width="38"
          >
            <template slot-scope="scope">
              <div class="flexCenter">
                <div
                  class="divCurcleStatus"
                  :class="scope.row.personal.color"
                ><span class="fs-10 fw-700 scorelabel">{{ scope.row.personal.score === 0 && scope.row.personal.color === '#C7C7C7' ? '?' : Math.round(scope.row.personal.score) }}</span></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Co_Alignment')"
            label-class-name="labelTable"
            :render-header="renderPhaseHeader"
            width="38"
          >
            <template slot-scope="scope">
              <div class="flexCenter">
                <div
                  class="divCurcleStatus"
                  :class="scope.row.alignment.color"
                ><span class="fs-10 fw-700 scorelabel">{{ scope.row.alignment.score === 0 && scope.row.alignment.color === '#C7C7C7' ? '?' : Math.round(scope.row.alignment.score) }}</span></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('insights.Satisfaction')"
            label-class-name="labelTable"
            :render-header="renderPhaseHeader"
            width="38"
          >
            <template slot-scope="scope">
              <div class="flexCenter">
                <div
                  class="divCurcleStatus"
                  :class="scope.row.satisfaction.color"
                ><span class="fs-10 fw-700 scorelabel">{{ scope.row.satisfaction.score === 0 && scope.row.satisfaction.color === '#C7C7C7' ? '?' : Math.round(scope.row.satisfaction.score) }}</span></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label label-class-name="labelTable" width="12">
            <template>
              <div class="flexCenter"></div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="right"
            label="Avg Impact"
            width="62"
            label-class-name="labelRateTable-spam"
            class-name="line-break tag"
          >
          <template slot="header">
              <el-tooltip content="The average impact rating score of team members, calculated as the sum of their individual impact scores divided by the number of members" placement="top">
                <span>Avg Impact</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <div class="flex-mid">
                <div
                  class="impact-tag px-2 fw-700"
                  :class="`impact-tag-${(scope.row.avgimpact == undefined || scope.row.avgimpact == '-') ?  'gray' : scope.row.avgimpact_color}`"
                  style="line-height: 18px; font-size: 12px; width: 50px;"
                >
                {{
                  `${(scope.row.avgimpact == undefined || scope.row.avgimpact == '-') ? '-' : Math.round(scope.row.avgimpact)}`
                }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="right"
            label="DEBI Score"
            width="64"
            label-class-name="labelRateTable-spam"
            class-name="line-break tag"
          >
            <template slot="header">
              <el-tooltip content="The Dynamic Engagement Behavioral Index (DEBI) for each team is determined by several factors: the frequency of team members' check-ins and responses, the quality of their feedback, their activity in recognizing peers, and their alignment with the organization's core values." placement="top">
                <span>DEBI Score</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-tooltip effect="light" :disabled="false">
                <div slot="content">
                  <div
                    :class="`content-container-insightsReport`"
                    :style="`width: 325px;`"
                  >
                    <div class="flex-center fs-11">
                      <div>
                        <div class="fw-900 fc-2B2B2B mr-auto">
                          ENGAGEMENT SCORE
                        </div>
                        <div class="fs-11 mt-4">
                          Dynamic Engagement Behavioral Index by role 
                        </div>
                          <div v-if="!loadingDataEngagement" style="justify-content: flex-start">
                            <div class="flex">
                              <div>
                                <div class="fs-12 chart-legend first">
                                  <div class="label">Overall</div>
                                  <div class="symbol blue"></div>
                                  <div class="score">{{ (databarchartEngagementScore['team'] && databarchartEngagementScore['team_members'] && databarchartEngagementScore['team_members'][databarchartEngagementScore['team_members'].length - 1] > 0) ? databarchartEngagementScore['team'][databarchartEngagementScore['team'].length - 1] : '-' }}</div>
                                </div>
                              </div>
                              <div>
                                <div class="fs-12 chart-legend">
                                  <div class="label">Manager</div>
                                  <div class="symbol orange"></div>
                                  <div class="score">{{ (databarchartEngagementScore['manager'] && databarchartEngagementScore['manager_members'] && databarchartEngagementScore['manager_members'][databarchartEngagementScore['manager_members'].length - 1] > 0) ? databarchartEngagementScore['manager'][databarchartEngagementScore['manager'].length - 1] : '-' }}</div>
                                </div>
                              </div>
                              <div>
                                <div class="fs-12 chart-legend">
                                  <div class="label">Leader</div>
                                  <div class="symbol pink"></div>
                                  <div class="score">{{ (databarchartEngagementScore['leader'] && databarchartEngagementScore['leader_members'] && databarchartEngagementScore['leader_members'][databarchartEngagementScore['leader_members'].length - 1] > 0) ? databarchartEngagementScore['leader'][databarchartEngagementScore['leader'].length - 1] : '-' }}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                    <div class="relative" style="height: 140px">
                      <div
                        class="center mt-10 mb-40 pt-10 pb-40"
                        v-if="loadingDataEngagement"
                      >
                        <loading-even></loading-even>
                      </div>
                      <canvas
                        :ref="`engagement_${scope.row.id}`"
                        height="120px;"
                        class=""
                      ></canvas>
                    </div>
                    <div class="fs-11 fc-2B2B2B opa-03 right">
                      {{ $t("insights.Most_Recent") }}
                    </div>
                  </div>
                </div>
                <div
                  class="flex-center cursor-pointer"
                  @mouseover.prevent="showingHistoryMainEngagementTable(scope.row)"
                >
                  <div
                    class="impact-tag ml-auto fw-700"
                    :class="`impact-tag-${detectColorTotal(scope.row.engagement_score)}`"
                    style="line-height: 18px; font-size: 12px; width: 50px; margin-left: 14px;"
                  >
                  {{
                  `${(scope.row.engagement_score !== undefined && !isNaN(scope.row.engagement_score)) ? Math.round(scope.row.engagement_score) : scope.row.engagement_score}`
                  }}
                  </div>
               
                </div>
              </el-tooltip>
              
            </template>
          </el-table-column>
          <el-table-column
            header-align="right"
            label="6-mo Retention"
            width="68"
            label-class-name="labelRateTable-spam"
            class-name="line-break tag"
          >
          <template slot="header">
              <el-tooltip content="The 6-month retention rate, calculated as the percentage of team members who remain employed. Formula: Current Team Size ÷ (Current Team Size + Employees Archived in Last 6 Months) × 100" placement="top">
                <span>6-mo Retention</span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-tooltip effect="light" :disabled="false">
                <div slot="content">
                  <div
                    :class="`content-container-insightsReport`"
                    :style="`width: 325px;`"
                  >
                    <div class="flex-center fs-11">
                      <div>
                        <div class="fw-900 fc-2B2B2B mr-auto">
                          ARCHIVED MEMBERS HISTORY
                        </div>
                        <div class="fs-11 mt-4">
                          Number of archived members by month
                        </div>
                      </div>
                      <div class="ml-auto fs-11">
                        <div class="flex-center">
                          <div
                            style="
                              width: 18px;
                              height: 14px;
                              background: #ffbcb7;
                            "
                          >
                            &nbsp;
                          </div>
                          <div class="fw-700 fc-2B2B2B mr-4 ml-6">
                            Terminated
                          </div>
                        </div>
                        <div class="flex-center mt-4">
                          <div
                            style="
                              width: 18px;
                              height: 14px;
                              background: #f44336;
                            "
                          >
                            &nbsp;
                          </div>
                          <div class="fw-700 fc-2B2B2B mr-4 ml-6">Resigned</div>
                        </div>
                      </div>
                    </div>
                    <div class="pt-20 relative" style="height: 140px">
                      <div
                        class="center mt-10 mb-40 pt-10 pb-40"
                        v-if="loadingChartInTable"
                      >
                        <loading-even></loading-even>
                      </div>
                      <canvas
                        :ref="scope.row.id"
                        height="120px;"
                        class=""
                      ></canvas>
                    </div>
                    <div class="fs-11 fc-2B2B2B opa-03 right">
                      {{ $t("insights.Most_Recent") }}
                    </div>
                  </div>
                </div>
                <div
                  class="flex-center cursor-pointer"
                  @mouseover.prevent="showingHistoryMainTable(scope.row)"
                >
                  <div
                    class="impact-tag ml-auto fw-700"
                    :class="`impact-tag-${(scope.row.retention_rate == undefined || scope.row.retention_rate == '-') ?  'gray' : scope.row.retention_color}`"
                    style="line-height: 18px; font-size: 12px; width: 50px"
                  >
                  {{
                  `${(scope.row.retention_rate == undefined || scope.row.retention_rate == '-') ? '-' : Math.round(scope.row.retention_rate) + '%'}`
                  }}
                  </div>
               
                </div>
              </el-tooltip>
              
            </template>
          </el-table-column>
          <el-table-column label label-class-name="labelTable" width="6">
            <template>
              <div class="flexCenter"></div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div id="teamModal">
      <el-dialog top="10vh" :visible.sync="spotlightTeamStatus">
        <div class="px-32 py-24 modal-header"
        :class="[ blurMode ?  'blurelement': '' ]">
          {{ findTeamNameByKey(modalTitle) }}
        </div>
        <div class="px-32 pb-24">
          <div class="flex-mid pt-20">
            <div class="flex-1">
              <span class="txtHeaderCard">HEALTH OVERVIEW</span>
            </div>
            <div class="pr-12">
              <span class="fc-4A4A4A">{{ $t("insights.Duration") }}</span>
            </div>
            <div class="showOption">
              <el-menu
                class="el-menu-demo menuOptionStyle"
                mode="horizontal"
                style="width: 200px"
              >
                <el-submenu index="0" style="width: 200px">
                  <template slot="title">
                    <span class="txtOption2">{{ selectModalMonth }}</span>
                  </template>
                  <el-menu-item
                    index="1"
                    class="is-active"
                    @click="handleModalMonth('30-days')"
                    style="font-size: 16px; width: 200px"
                    >{{ $t("insights.Last_30_days") }}</el-menu-item
                  >
                  <el-menu-item
                    index="2"
                    class="is-active"
                    @click="handleModalMonth('60-days')"
                    style="font-size: 16px; width: 200px"
                    >{{ $t("insights.Last_60_days") }}</el-menu-item
                  >
                  <el-menu-item
                    index="3"
                    class="is-active"
                    @click="handleModalMonth('13-weeks')"
                    style="font-size: 16px; width: 200px"
                    >{{ $t("insights.Last_13_weeks") }}</el-menu-item
                  >
                  <el-menu-item
                    index="3"
                    class="is-active"
                    @click="handleModalMonth('26-weeks')"
                    style="font-size: 16px; width: 200px"
                    >{{ $t("insights.Last_26_weeks") }}</el-menu-item
                  >
                  <el-menu-item
                    index="3"
                    class="is-active"
                    @click="handleModalMonth('52-weeks')"
                    style="font-size: 16px; width: 200px"
                    >{{ $t("insights.Last_52_weeks") }}</el-menu-item
                  >
                  <el-menu-item
                    index="3"
                    class="is-active"
                    @click="handleModalMonth('24-months')"
                    style="font-size: 16px; width: 200px"
                    >{{ $t("insights.Last_24_months") }}</el-menu-item
                  >
                </el-submenu>
              </el-menu>
            </div>
            <div class="pl-10">
              <img
                @click="exportChart('modal')"
                :src="$utils('icons', 'ic_xls_download')"
                class="mt-3 icon-export"
              />
            </div>
          </div>
          <div class="chart-bar relative">
            <div
              class="loading-chart-bar flex-mid pt-8"
              v-if="loadingDataModal"
            >
              <loading-even></loading-even>
            </div>
            <div class="flex-mid" v-else-if="chartInModalNodataStatus">
              No data.
            </div>
            <div class="flex-mid" v-else>
              <div class="chart-type-bar green"></div>
              <div class="type-bar-text">{{ $t("insights.HAPPINESS") }}</div>
              <div class="chart-type-bar red"></div>
              <div class="type-bar-text">{{ $t("insights.RISK") }}</div>
              <div class="chart-type-bar line">
                <div></div>
              </div>
              <div class="type-bar-text">{{ $t("insights.ACTIVE_USERS") }}</div>
            </div>
            <div
              v-if="
                !loadingDataModal &&
                Object.keys(this.dataBarChartModal).length == 0
              "
              class="absolute-mid"
              style="height: 197px; width: 100%"
            >
              <img
                class="absolute-mid"
                src="@/assets/images/insights/bar_chart_empty_state.png"
              />
              <div class="absolute-mid center fs-12 fw-500" style="width: 100%">
                {{ $t("insights.There_is_no_happiness") }}
              </div>
            </div>
            <div>
              <div style="height: 180px">
                <canvas ref="chartBarModal"></canvas>
              </div>
            </div>
          </div>
          <!-- Dimension Trends -->
          <div class="fs-15 fw-700 mt-24" style="color: #4A4A4A;">DIMENSION TRENDS</div>
          <div class="fs-12 mt-4" style="color: #999; line-height: 1.4;">Recent dimension scores for this team. The team manager receives these in their weekly insights, with actionable recommendations when areas need attention.</div>

          <!-- Loading skeleton -->
          <div v-if="loadingDimensionTrends" class="dimension-trends-grid mt-12">
            <div v-for="n in 9" :key="'skel-' + n" class="dimension-trend-card skeleton-pulse">
              <div class="skeleton-line" style="width: 55%; height: 13px;"></div>
              <div class="skeleton-line" style="width: 35%; height: 20px; margin-top: 4px;"></div>
              <div style="display: flex; gap: 6px; margin-top: 12px;">
                <div v-for="d in 6" :key="d" class="skeleton-dot"></div>
              </div>
            </div>
          </div>

          <!-- Loaded content -->
          <div v-else class="dimension-trends-grid mt-12">
            <div v-for="dim in modalDimensionTrends" :key="dim.key" class="dimension-trend-card">
              <div class="dimension-trend-header">
                <span class="fs-13 fw-700" style="color: #4A4A4A;">{{ dim.label }}</span>
                <span class="fs-14 fw-700 dimension-trend-score" :class="dim.currentColor || ''">
                  {{ dim.currentScore != null ? dim.currentScore + '%' : '-' }}
                </span>
              </div>
              <div v-if="dim.question" class="fs-11 mt-2" style="color: #999; line-height: 1.3; overflow-wrap: break-word; word-break: normal;">
                {{ dim.question }}
              </div>
              <div v-if="dim.history.length > 0" class="mt-10">
                <div class="trend-dots-row">
                  <el-tooltip v-for="(point, idx) in dim.history" :key="idx"
                    :content="(point.label ? point.label + ': ' : '') + point.score + '%'" placement="top" :open-delay="200">
                    <div class="trend-dot" :class="point.color"></div>
                  </el-tooltip>
                </div>
                <div class="fs-10 mt-4" style="color: #AAAAAA;">{{ dim.periodRange }}</div>
              </div>
              <div v-else class="fs-11 mt-10" style="color: #C7C7C7;">No data for this period</div>
            </div>
          </div>
          <div class="headerCard2">
            <div class="flex-1 mt-10">
              <span class="txtHeaderCard">{{
                $t("insights.TEAM_STATUS")
              }}</span>
            </div>
            <div style="padding-right: 12px; margin-top: 10px">
              <span class="fc-4A4A4A">{{ $t("insights.Sort_by") }}</span>
            </div>
            <div class="showOption">
              <el-menu
                class="el-menu-demo menuOptionStyle"
                mode="horizontal"
                style="width: 200px"
              >
                <el-submenu :index="`${selectModalSort}`" style="width: 200px">
                  <template slot="title">
                    <span class="txtOption2">{{
                      optionsSort[selectModalSort]
                    }}</span>
                  </template>
                  <el-menu-item
                    v-for="(value, key) in optionsSort"
                    :key="`MODAL-${key}`"
                    :index="`${key}`"
                    @click="sortByModal"
                    style="font-size: 16px; width: 200px"
                    >{{ value }}</el-menu-item
                  >
                </el-submenu>
              </el-menu>
            </div>
          </div>
          <div class="divTable" style="min-height: 300px">
            <div v-if="realDataModalTreeTable.length === 0 && !modalTableDataReady" class="center mt-20 mb-40 pt-20 pb-40">
              <loading-even></loading-even>
            </div>
            <el-table
              v-show="realDataModalTreeTable.length > 0 || modalTableDataReady"
              id="teamsTable"
              :data="realDataModalTreeTable"
              :empty-text="'There is no data to display for the current time period.'"
              ref="modalTeamsTable"
              style="width: 100%"
              :cell-style="cellStyle"
              row-key="id"
              lazy
              :expand-row-keys="modalExpandKeys"
              :load="loadModal"
              :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            >
              <el-table-column
                :remote="remoteMainPage"
                label-class-name="labelTeamTable"
                class-name="cell-with-nowrap"
                :label="$t('insights.Team')"
              >
                <template slot-scope="scope">
                  <span
                    class="text-open-modal ellipsis"
                    :class="[ blurMode ?  'blurelement': '' ]"
                    @click="showModal(scope.row.id)"
                    >{{ scope.row.team }}</span
                  >
                </template>
              </el-table-column>
              <!-- :label="$t('insights.Happi_Rate')" -->
              <el-table-column
                label="Happiness Rate"
                width="80"
                label-class-name="labelRateTable"
                class-name="line-break"
                align="right"
              >
                <template slot-scope="scope">{{
                  `${scope.row.happirate}%`
                }}</template>
              </el-table-column>
              <el-table-column
                :label="$t('insights.Risk_Rate')"
                width="58"
                align="right"
                label-class-name="labelRateTable word-break"
                class-name="line-break"
              >
                <template slot-scope="scope">{{
                  `${scope.row.riskrate}%`
                }}</template>
              </el-table-column>
              <el-table-column
                :label="$t('insights.Feedback')"
                label-class-name="labelTable"
                :render-header="renderPhaseHeader"
                width="38"
              >
                <template slot-scope="scope">
                  <div class="flexCenter">
                    <div
                  class="divCurcleStatus"
                  :class="scope.row.feedback.color"
                ><span class="fs-10 fw-700 scorelabel">{{ scope.row.feedback.score === 0 && scope.row.feedback.color === '#C7C7C7' ? '?' : Math.round(scope.row.feedback.score) }}</span></div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('insights.Wellness')"
                label-class-name="labelTable"
                :render-header="renderPhaseHeader"
                width="38"
              >
                <template slot-scope="scope">
                  <div class="flexCenter">
                    <div
                  class="divCurcleStatus"
                  :class="scope.row.wellness.color"
                ><span class="fs-10 fw-700 scorelabel">{{ scope.row.wellness.score === 0 && scope.row.wellness.color === '#C7C7C7' ? '?' : Math.round(scope.row.wellness.score) }}</span></div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('insights.Rel_Manager')"
                label-class-name="labelTable"
                :render-header="renderPhaseHeader"
                width="45"
              >
                <template slot-scope="scope">
                  <div class="flexCenter">
                    <div
                  class="divCurcleStatus"
                  :class="scope.row.manager.color"
                ><span class="fs-10 fw-700 scorelabel">{{ scope.row.manager.score === 0 && scope.row.manager.color === '#C7C7C7' ? '?' : Math.round(scope.row.manager.score) }}</span></div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('insights.Recognition')"
                label-class-name="labelTable"
                :render-header="renderPhaseHeader"
                width="46"
              >
                <template slot-scope="scope">
                  <div class="flexCenter">
                    <div
                  class="divCurcleStatus"
                  :class="scope.row.recognition.color"
                ><span class="fs-10 fw-700 scorelabel">{{ scope.row.recognition.score === 0 && scope.row.recognition.color === '#C7C7C7' ? '?' : Math.round(scope.row.recognition.score) }}</span></div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('insights.Ambassadorship')"
                label-class-name="labelTable"
                :render-header="renderPhaseHeader"
                width="38"
              >
                <template slot-scope="scope">
                  <div class="flexCenter">
                    <div
                      class="divCurcleStatus"
                      :class="scope.row.ambassadorship.color"
                    ><span class="fs-10 fw-700 scorelabel">{{ scope.row.ambassadorship.score === 0 && scope.row.ambassadorship.color === '#C7C7C7' ? '?' : Math.round(scope.row.ambassadorship.score) }}</span></div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('insights.Rel_Colleagues')"
                label-class-name="labelTable"
                :render-header="renderPhaseHeader"
                width="38"
              >
                <template slot-scope="scope">
                  <div class="flexCenter">
                    <div
                      class="divCurcleStatus"
                      :class="scope.row.colleagues.color"
                    ><span class="fs-10 fw-700 scorelabel">{{ scope.row.colleagues.score === 0 && scope.row.colleagues.color === '#C7C7C7' ? '?' : Math.round(scope.row.colleagues.score) }}</span></div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('insights.Personal_Growth')"
                label-class-name="labelTable"
                :render-header="renderPhaseHeader"
                width="38"
              >
                <template slot-scope="scope">
                  <div class="flexCenter">
                    <div
                      class="divCurcleStatus"
                      :class="scope.row.personal.color"
                    ><span class="fs-10 fw-700 scorelabel">{{ scope.row.personal.score === 0 && scope.row.personal.color === '#C7C7C7' ? '?' : Math.round(scope.row.personal.score) }}</span></div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('insights.Co_Alignment')"
                label-class-name="labelTable"
                :render-header="renderPhaseHeader"
                width="38"
              >
                <template slot-scope="scope">
                  <div class="flexCenter">
                    <div
                      class="divCurcleStatus"
                      :class="scope.row.alignment.color"
                    ><span class="fs-10 fw-700 scorelabel">{{ scope.row.alignment.score === 0 && scope.row.alignment.color === '#C7C7C7' ? '?' : Math.round(scope.row.alignment.score) }}</span></div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('insights.Satisfaction')"
                label-class-name="labelTable"
                :render-header="renderPhaseHeader"
                width="38"
              >
                <template slot-scope="scope">
                  <div class="flexCenter">
                    <div
                      class="divCurcleStatus"
                      :class="scope.row.satisfaction.color"
                    ><span class="fs-10 fw-700 scorelabel">{{ scope.row.satisfaction.score === 0 && scope.row.satisfaction.color === '#C7C7C7' ? '?' : Math.round(scope.row.satisfaction.score) }}</span></div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label label-class-name="labelTable" width="12">
                <template>
                  <div class="flexCenter"></div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="right"
                label="Avg Impact"
                width="52"
                label-class-name="labelRateTable-spam"
                class-name="line-break tag"
              >
              <template slot-scope="scope">
                  <div class="flex-center">
                    <div
                      class="impact-tag px-2 fw-700"
                      :class="`impact-tag-${(scope.row.avgimpact == undefined || scope.row.avgimpact == '-') ?  'gray' : scope.row.avgimpact_color}`"
                      style="line-height: 18px; font-size: 12px; width: 50px;"
                    >
                    {{
                      `${(scope.row.avgimpact == undefined) ? '-' : scope.row.avgimpact}`
                    }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="right"
                label="Engagement (DEBI)"
                width="68"
                label-class-name="labelRateTable-spam"
                class-name="line-break tag"
              >
                <template slot-scope="scope">
                  <el-tooltip effect="light" :disabled="false">
                    <div slot="content">
                      <div
                        :class="`content-container-insightsReport`"
                        :style="`width: 325px;`"
                      >
                        <div class="flex-center fs-11">
                          <div>
                            <div class="fw-900 fc-2B2B2B mr-auto">
                              ENGAGEMENT SCORE
                            </div>
                            <div class="fs-11 mt-4">
                              Dynamic Engagement Behavioral Index by role
                            </div>
                              <div v-if="!loadingDataEngagementModal" style="justify-content: flex-start">
                                <div class="flex">
                                  <div>
                                    <div class="fs-12 chart-legend">
                                      <div class="label">Overall</div>
                                      <div class="symbol blue"></div>
                                      <div class="score">{{ (databarchartEngagementScoreModal['team'] && databarchartEngagementScoreModal['team_members'] && databarchartEngagementScoreModal['team_members'][databarchartEngagementScoreModal['team_members'].length - 1] > 0) ? databarchartEngagementScoreModal['team'][databarchartEngagementScoreModal['team'].length - 1] : '-' }}</div>
                                    </div>
                                  </div>
                                  <div>
                                    <div class="fs-12 chart-legend">
                                      <div class="label">Manager</div>
                                      <div class="symbol orange"></div>
                                      <div class="score">{{ (databarchartEngagementScoreModal['manager'] && databarchartEngagementScoreModal['manager_members'] && databarchartEngagementScoreModal['manager_members'][databarchartEngagementScoreModal['manager_members'].length - 1] > 0) ? databarchartEngagementScoreModal['manager'][databarchartEngagementScoreModal['manager'].length - 1] : '-' }}</div>
                                    </div>
                                  </div>
                                  <div>
                                    <div class="fs-12 chart-legend">
                                      <div class="label">Leader</div>
                                      <div class="symbol pink"></div>
                                      <div class="score">{{ (databarchartEngagementScoreModal['leader'] && databarchartEngagementScoreModal['leader_members'] && databarchartEngagementScoreModal['leader_members'][databarchartEngagementScoreModal['leader_members'].length - 1] > 0) ? databarchartEngagementScoreModal['leader'][databarchartEngagementScoreModal['leader'].length - 1] : '-' }}</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                          </div>
                        </div>
                        <div class="relative" style="height: 140px">
                          <div
                            class="center mt-10 mb-40 pt-10 pb-40"
                            v-if="loadingDataEngagementModal"
                          >
                            <loading-even></loading-even>
                          </div>
                          <canvas
                            :ref="`engagement_modal_${scope.row.id}`"
                            height="120px;"
                            class=""
                          ></canvas>
                        </div>
                        <div class="fs-11 fc-2B2B2B opa-03 right">
                          {{ $t("insights.Most_Recent") }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="flex-center cursor-pointer"
                      @mouseover.prevent="showingHistoryModalEngagementTable(scope.row)"
                    >
                      <div
                        class="impact-tag ml-auto fw-700"
                        :class="`impact-tag-${detectColorTotal(scope.row.engagement_score)}`"
                        style="line-height: 18px; font-size: 12px; width: 50px; margin-left: 14px;"
                      >
                      {{
                      `${scope.row.engagement_score}`
                      }}
                      </div>
                  
                    </div>
                  </el-tooltip>
                  
                </template>
              </el-table-column>
              <el-table-column
                header-align="right"
                label="6-mo Retention"
                width="68"
                label-class-name="labelRateTable-spam"
                class-name="line-break tag"
              >
                <template slot-scope="scope">
                  <el-tooltip effect="light" :disabled="false">
                    <div slot="content">
                      <div
                        :class="`content-container-insightsReport`"
                        :style="`width: 325px;`"
                      >
                        <div class="flex-center fs-11">
                          <div>
                            <div class="fw-900 fc-2B2B2B mr-auto">
                              ARCHIVED MEMBERS HISTORY
                            </div>
                            <div class="fs-11 mt-4">
                              Number of archived members by month
                            </div>
                          </div>
                          <div class="ml-auto fs-11">
                            <div class="flex-center">
                              <div
                                style="
                                  width: 18px;
                                  height: 14px;
                                  background: #ffbcb7;
                                "
                              >
                                &nbsp;
                              </div>
                              <div class="fw-700 fc-2B2B2B mr-4 ml-6">
                                Terminated
                              </div>
                            </div>
                            <div class="flex-center mt-4">
                              <div
                                style="
                                  width: 18px;
                                  height: 14px;
                                  background: #f44336;
                                "
                              >
                                &nbsp;
                              </div>
                              <div class="fw-700 fc-2B2B2B mr-4 ml-6">
                                Resigned
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="pt-20 relative" style="height: 140px">
                          <div
                            class="center mt-10 mb-40 pt-10 pb-40"
                            v-if="loadingChartInTable"
                          >
                            <loading-even></loading-even>
                          </div>
                          <canvas
                            :ref="'modal_' + scope.row.id"
                            height="120px;"
                            class=""
                          ></canvas>
                        </div>
                        <div class="fs-11 fc-2B2B2B opa-03 right">
                          {{ $t("insights.Most_Recent") }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="flex-center cursor-pointer"
                      @mouseover.prevent="showingHistoryModalTable(scope.row)"
                    >
                      <div
                        class="impact-tag ml-auto fw-700"
                        :class="`impact-tag-${(scope.row.retention_rate == undefined || scope.row.retention_rate == '-') ?  'gray' : scope.row.retention_color}`"
                        style="line-height: 18px; font-size: 12px; width: 50px;"
                      >
                        {{
                        `${(scope.row.retention_rate == undefined) ? '-' : scope.row.retention_rate}`
                        }}
                      </div>
                    </div>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column label label-class-name="labelTable" width="6">
                <template>
                  <div class="flexCenter"></div>
                </template>
              </el-table-column>
            </el-table>
            <download-progress
              :wording="wordingSnackBar"
              :active="showSnackbar"
            ></download-progress>
          </div>
        </div>
      </el-dialog>
      <download-progress
        :wording="wordingSnackBar"
        :active="showSnackbar"
      ></download-progress>
    </div>
  </div>
</template>
<script>
import Chart from "chart.js/auto";
import chartDataResignedLabels from "chartjs-plugin-datalabels";
import getDay from "date-fns/get_day";
import addDays from "date-fns/add_days";
import addMonths from "date-fns/add_months";
import startOfWeek from "date-fns/start_of_week";
import subWeeks from "date-fns/sub_weeks";
import lastDayOfWeek from "date-fns/last_day_of_week";
// var startOfWeek = require('date-fns/start_of_week')

export default {
  name: "teams",
  components: {
    loadingEven: require("../even/loading").default,
    downloadProgress: require("../even/download-progress").default,
  },
  async created() {
    this.initializeSortOptions();
    await this.initializeTeamsView();
  },
  computed: {
    user() {
      return this.$store.getters["authen/user"];
    },
    expandProps() {
      return this.$store.getters["navCommands/getExpandProps"];
    },
    optionsTeam() {
      return this.$store.getters["team/teamsall"];
    },
    getInsightTeams() {
      return this.$store.getters["teams/insightteams"];
    },
    getInsightTeamsModal() {
      return this.$store.getters["teams/insightteamsModal"];
    },
    datachart() {
      return this.$store.getters["teams/datachart"];
    },
    overviewWeeklyActive() {
      return this.$store.getters["teams/overviewWeeklyActive"];
    },
    overviewWeeklyHealth() {
      return this.$store.getters["teams/overviewWeeklyHealth"];
    },
    dataBarChartModal() {
      return this.$store.getters["teams/datachartModal"];
    },
    questionsName() {
      return this.$store.getters["dashboard/questions_name"];
    },
    dimensionTrendsData() {
      return this.$store.getters["teams/dimensionTrendsModal"];
    },
    loadingDimensionTrends() {
      return this.$store.getters["teams/loadingDimensionTrends"];
    },
    modalDimensionTrends() {
      const trendsData = this.dimensionTrendsData;
      if (!trendsData || Object.keys(trendsData).length === 0) return [];
      const dimensions = [
        { key: 'feedback', label: 'Feedback', questId: '-L1QWPtZvax_KlJgpNxF' },
        { key: 'wellness', label: 'Wellness', questId: '-L36rxTgLhZTL4mq4SV1' },
        { key: 'manager', label: 'Rel. Manager', questId: '-L1Qug-PhtzVOR2Dr5q7' },
        { key: 'recognition', label: 'Recognition', questId: '-L0J5FFsGQYVkfcGujWo' },
        { key: 'ambassadorship', label: 'Ambassadorship', questId: '-L2ycGiBDo3rDGjLNKwW' },
        { key: 'colleagues', label: 'Rel. Colleagues', questId: '-Kgs549ClADmNQwoNbbG' },
        { key: 'personal', label: 'Personal Growth', questId: '-Kgn7oxLPPWlbM_ZDc_h' },
        { key: 'alignment', label: 'Co. Alignment', questId: '-LtOL_iR1N-ev2b_8Tmg' },
        { key: 'satisfaction', label: 'Satisfaction', questId: '-L1FmpFO-v8IZc_B5EB7' },
      ];
      return dimensions.map(dim => {
        const dimData = trendsData[dim.key] || {};
        const history = Array.isArray(dimData.points) ? dimData.points : [];
        const current = dimData.current && dimData.current.score != null
          ? dimData.current
          : null;
        // Use current snapshot score (from insight_teams_fix, same as Team Status)
        // Fall back to last historical point if no current snapshot
        const last = history.length > 0 ? history[history.length - 1] : null;
        const currentScore = current
          ? current.score
          : (last && last.score != null ? last.score : null);
        const currentColor = current
          ? current.color
          : (last ? last.color : '');
        const question = this.questionsName ? this.questionsName[dim.questId] : '';
        return {
          key: dim.key,
          label: dim.label,
          question: question || '',
          currentScore,
          currentColor,
          history,
          periodRange: dimData.rangeLabel || ''
        };
      });
    },
    datalist() {
      return this.$store.getters["teams/datalist"];
    },
    datalistModal() {
      return this.$store.getters["teams/datalistModal"];
    },
    loadingDataModal() {
      return this.$store.getters["teams/loadingDataModal"];
    },
    loadingData() {
      return this.$store.getters["teams/loadingData"];
    },
    loadingDataListTable() {
      return this.$store.getters["teams/dataListLoading"];
    },
    mostengage() {
      return this.$store.getters["teams/mostengage"];
    },
    retentionrisks() {
      return this.$store.getters["teams/retentionrisks"];
    },
    mostimprove() {
      return this.$store.getters["teams/mostimprove"];
    },
    mostcritical() {
      return this.$store.getters["teams/mostcritical"];
    },
    showSnackbar() {
      return this.$store.getters["teams/showSnackbar"];
    },
    loadingDataEngagement() {
      return this.$store.getters["teams/loadingDataEngagement"];
    },
    loadingDataEngagementModal() {
      return this.$store.getters["teams/loadingDataEngagementModal"];
    },
    databarchartEngagementScore() {
      return this.$store.getters["teams/databarchartEngagementScore"];
    },
    databarchartEngagementScoreModal() {
      return this.$store.getters["teams/databarchartEngagementScoreModal"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    teamMetrics() {
      if (this.selectTeam === 'all') {
        return this.calculateAllTeamsMetrics();
      }
      return this.calculateTeamMetrics(this.selectTeam);
    },
  },
  data() {
    return {
      wordingSnackBar: "Preparing team data, please wait...",
      activeWhere: {},
      activeWhereModal: {},
      expands: [],
      hoverTeam: "",
      hoverModalTeam: "",
      selectTeam: "",
      selectTeamModal: "",
      selectMainPageMonth: "60-days",
      selectMainPageMonthKey: "60-days",
      selectModalMonth: "60-days",
      selectModalMonthKey: "60-days",
      tooltipVisible: false,
      tooltipContent: '',
      tooltipStyle: {},
      optionsMainPageMonthName: [],
      optionsMainPageMonth: [],
      optionsModalMonthName: [],
      optionsModalMonth: [],
      myChart: "",
      myModalBarChart: "",
      optionsSort: [],
      selectModalSort: 0,
      selectMainPageSort: 0,
      spotlightTeamStatus: false,
      dataAllList: [],
      dataAllListModal: [],
      teamStatusChanged: true,
      modalTitle: "",
      dataMainPageChanged: true,
      mostengageMain: [],
      retentionrisksMain: [],
      mostimproveMain: [],
      mostcriticalMain: [],
      // loadingModalChartStatus: true,
      newLabels: [],
      newLabelsfulldate: [],
      newLabelsModal: [],
      newLabelsModalfulldate: [],
      realDataMainTreeTable: [],
      realDataModalTreeTable: [],
      mainExpandKeys: [],
      modalExpandKeys: [],
      chartInModalNodataStatus: false,
      loadingMainData: true,
      loadingModalData: true,
      mainTableDataReady: false,
      modalTableDataReady: false,
      loadingChartInTable: false,
      barChartTooltipBarChartOnMain: null,
      barChartTooltipBarChartOnModal: null,
      barChartTooltipBarChartOnMainEngagement: null,
      barChartTooltipBarChartOnModalEngagement: null,
      teamsViewReady: false,
      viewMounted: false,
      mainScopeRequestId: 0,
      modalScopeRequestId: 0,
      mainChartRequestId: 0,
      modalChartRequestId: 0,
    };
  },
  mounted() {
    this.viewMounted = true;
    this.$nextTick(() => {
      if (Object.keys(this.datachart || {}).length > 0) {
        this.randerMainPageChart();
      }
      if (this.spotlightTeamStatus && Object.keys(this.dataBarChartModal || {}).length > 0) {
        this.randerBarChartModal();
      }
    });
  },
  beforeDestroy() {
    this.destroyAllCharts();
  },
  watch: {
    databarchartEngagementScore() {
      if (this.barChartTooltipBarChartOnMainEngagement)
        this.barChartTooltipBarChartOnMainEngagement.destroy();
      this.generateChartTooltipOnMainEngagement();
    },
    databarchartEngagementScoreModal() {
      if (this.barChartTooltipBarChartOnModalEngagement)
        this.barChartTooltipBarChartOnModalEngagement.destroy();
      this.generateChartTooltipOnModalEngagement();
    },
    optionsTeam() {
      if (!this.selectTeam && this.optionsTeam.length > 0) {
        this.selectTeam =
          this.user.user_type == "leadership" ? this.user.team : "all";
      }
    },
    datachart() {
      if (this.myChart && this.dataMainPageChanged) {
        this.myChart.destroy();
      }
      if (this.viewMounted && Object.keys(this.datachart).length > 0) {
        this.randerMainPageChart();
      }
    },
    dataBarChartModal() {
      if (this.myModalBarChart) {
        this.myModalBarChart.destroy();
      }
      if (
        this.viewMounted &&
        this.spotlightTeamStatus &&
        Object.keys(this.dataBarChartModal).length > 0
      ) {
        this.randerBarChartModal();
      }
    },
    datalist: {
      immediate: true,
      handler(value) {
        this.dataAllList = Array.isArray(value) ? value : [];
        this.dataMainTreeTable();
      },
    },
    datalistModal: {
      immediate: true,
      handler(value) {
        this.dataAllListModal = Array.isArray(value) ? value : [];
        this.dataModalTreeTable();
      },
    },
    mostcritical() {
      if (this.teamStatusChanged === true) {
        this.mostengageMain = this.mostengage;
        this.retentionrisksMain = this.retentionrisks;
        this.mostimproveMain = this.mostimprove;
        this.mostcriticalMain = this.mostcritical;
        this.teamStatusChanged = false;
      }
    },
  },
  methods: {
    calculateTrendFromWeeklyCache(metricType) {
      if (metricType !== 'activeUsers') return null;
      if (!this.overviewWeeklyActive || !this.overviewWeeklyActive.activeuser || this.overviewWeeklyActive.activeuser.length < 2) {
        return null;
      }
      const series = this.overviewWeeklyActive.activeuser.filter(v => v !== null && v !== undefined);
      if (series.length < 2) return null;
      const current = series.length > 2 ? series[series.length - 2] : series[series.length - 1];
      const previous = series.length > 2 ? series[series.length - 3] : series[series.length - 2];
      if (previous === 0 || previous === null || previous === undefined) return null;
      return Math.round(current - previous);
    },
    calculateTrendFromWeeklyHealth(metricType) {
      if (!this.overviewWeeklyHealth) return null
      let series = []
      if (metricType === 'happiness') {
        series = (this.overviewWeeklyHealth.happy || []).filter(v => v > 0)
      } else if (metricType === 'risk') {
        series = (this.overviewWeeklyHealth.risk || []).filter(v => v !== 0 && v !== null && v !== undefined)
      } else {
        return null
      }
      if (series.length < 2) return null
      const current = series.length > 2 ? series[series.length - 2] : series[series.length - 1]
      const previous = series.length > 2 ? series[series.length - 3] : series[series.length - 2]
      if (previous === 0 || previous === null || previous === undefined) return null
      const change = current - previous
      // For risk, we display negative numbers for improvements (lower risk)
      // so do not invert the sign here
      return Math.round(change)
    },
    initializeSortOptions() {
      if (this.optionsSort.length > 0) {
        return;
      }

      this.optionsSort = [
        this.$t("insights.Lowest_Happiness"),
        this.$t("insights.Highest_Happiness"),
        this.$t("insights.Lowest_Risk"),
        this.$t("insights.Highest_Risk"),
      ];
    },
    getDefaultTeamSelection() {
      return this.user.user_type == "leadership" ? this.user.team : "all";
    },
    getInitialTeamSelection() {
      if (
        this.expandProps.navCall &&
        this.expandProps.memberObject &&
        this.expandProps.memberObject.key
      ) {
        return this.expandProps.memberObject.key;
      }

      return this.getDefaultTeamSelection();
    },
    getInitialMainPeriodKey() {
      if (
        this.expandProps.navCall &&
        this.expandProps.expandTime &&
        this.expandProps.expandTime.key
      ) {
        return this.expandProps.expandTime.key;
      }

      return this.selectMainPageMonthKey;
    },
    nextMainScopeRequestId() {
      const requestId = this.mainScopeRequestId + 1;
      this.mainScopeRequestId = requestId;
      this.$store.commit("teams/setMainRequestKey", requestId);
      return requestId;
    },
    nextMainChartRequestId() {
      const requestId = this.mainChartRequestId + 1;
      this.mainChartRequestId = requestId;
      this.$store.commit("teams/setMainChartRequestKey", requestId);
      return requestId;
    },
    nextModalScopeRequestId() {
      const requestId = this.modalScopeRequestId + 1;
      this.modalScopeRequestId = requestId;
      this.$store.commit("teams/setModalRequestKey", requestId);
      return requestId;
    },
    nextModalChartRequestId() {
      const requestId = this.modalChartRequestId + 1;
      this.modalChartRequestId = requestId;
      this.$store.commit("teams/setModalChartRequestKey", requestId);
      return requestId;
    },
    getMainTeamsTableRef() {
      return this.$refs.mainTeamsTable || null;
    },
    getModalTeamsTableRef() {
      return this.$refs.modalTeamsTable || null;
    },
    resetMainTableExpansion() {
      const tableRef = this.getMainTeamsTableRef();
      if (tableRef && tableRef.store && tableRef.store.states) {
        tableRef.store.states._treeRowExpanded = [];
      }
    },
    resetModalTableExpansion() {
      const tableRef = this.getModalTeamsTableRef();
      if (tableRef && tableRef.store && tableRef.store.states) {
        tableRef.store.states._treeRowExpanded = [];
      }
    },
    destroyAllCharts() {
      if (this.myChart) {
        this.myChart.destroy();
        this.myChart = null;
      }
      if (this.myModalBarChart) {
        this.myModalBarChart.destroy();
        this.myModalBarChart = null;
      }
      if (this.barChartTooltipBarChartOnMain) {
        this.barChartTooltipBarChartOnMain.destroy();
        this.barChartTooltipBarChartOnMain = null;
      }
      if (this.barChartTooltipBarChartOnModal) {
        this.barChartTooltipBarChartOnModal.destroy();
        this.barChartTooltipBarChartOnModal = null;
      }
      if (this.barChartTooltipBarChartOnMainEngagement) {
        this.barChartTooltipBarChartOnMainEngagement.destroy();
        this.barChartTooltipBarChartOnMainEngagement = null;
      }
      if (this.barChartTooltipBarChartOnModalEngagement) {
        this.barChartTooltipBarChartOnModalEngagement.destroy();
        this.barChartTooltipBarChartOnModalEngagement = null;
      }
    },
    buildPeriodConfig(optMonth) {
      const newDate = new Date();
      let textOption = this.$t("insights.Last_24_months");
      const optionNames = [];
      const options = [];
      const labels = [];
      const fullLabels = [];
      let activeWhere = {};

      if (optMonth == "30-days" || optMonth == "60-days") {
        const totalDays = optMonth == "30-days" ? 30 : 60;
        textOption =
          optMonth == "30-days"
            ? this.$t("insights.Last_30_days")
            : this.$t("insights.Last_60_days");
        activeWhere = {
          type: "days",
          start: this.$dateFns.format(addDays(newDate, -totalDays), "YYYY-MM-DD"),
        };

        newDate.setDate(newDate.getDate() - 1);
        for (let i = totalDays; i > 0; i--) {
          const currentDate = addDays(newDate, -(i - 1));
          const day = getDay(currentDate);
          if (day != 0 && day != 6) {
            optionNames.push(
              i % 7 === 0 ? this.$dateFns.format(currentDate, "DD MMM") : ""
            );
            labels.push(this.$dateFns.format(currentDate, "DD MMM"));
            fullLabels.push(this.$dateFns.format(currentDate, "DD MMMM"));
            options.push({
              startdate: this.$dateFns.format(currentDate, "YYYY-MM-DD"),
              enddate: this.$dateFns.format(currentDate, "YYYY-MM-DD"),
            });
          }
        }
      } else if (
        optMonth == "13-weeks" ||
        optMonth == "26-weeks" ||
        optMonth == "52-weeks"
      ) {
        let week = 13;
        if (optMonth == "13-weeks") {
          textOption = this.$t("insights.Last_13_weeks");
        } else if (optMonth == "26-weeks") {
          textOption = this.$t("insights.Last_26_weeks");
          week = 26;
        } else {
          textOption = this.$t("insights.Last_52_weeks");
          week = 52;
        }

        const startOfCurrentWeek = this.$dateFns.format(
          addDays(startOfWeek(newDate), 1),
          "YYYY-MM-DD"
        );
        const endOfCurrentWeek = this.$dateFns.format(
          addDays(lastDayOfWeek(newDate), 1),
          "YYYY-MM-DD"
        );

        for (let j = week - 1; j >= 0; j--) {
          const startweek = this.$dateFns.format(
            subWeeks(startOfCurrentWeek, j),
            "YYYY-MM-DD"
          );
          const lastweek = this.$dateFns.format(
            subWeeks(endOfCurrentWeek, j),
            "YYYY-MM-DD"
          );

          options.push({
            startdate: startweek,
            enddate: lastweek,
          });
          optionNames.push(this.$dateFns.format(startweek, "D MMM").toUpperCase());
          labels.push(this.$dateFns.format(startweek, "DD MMM"));
          fullLabels.push(this.$dateFns.format(startweek, "DD MMMM"));
        }

        if (options.length) {
          activeWhere = {
            type: "weeks",
            start: options[0].startdate,
          };
        }
      } else {
        for (let i = 23; i >= 0; i--) {
          const startDate = this.$dateFns.format(addMonths(newDate, -i), "YYYY-MM");
          optionNames.push(
            this.$dateFns.format(addMonths(newDate, -i), "MMM").toUpperCase()
          );
          options.push({
            startdate: startDate + "-01",
            enddate: startDate + "-31",
          });
          labels.push(startDate);
          fullLabels.push(startDate);
        }

        if (options.length) {
          activeWhere = {
            type: "months",
            start: options[0].startdate,
          };
        }
      }

      return {
        key: optMonth,
        textOption,
        optionNames,
        options,
        labels,
        fullLabels,
        activeWhere,
      };
    },
    applyMainPeriodConfig(optMonth) {
      const config = this.buildPeriodConfig(optMonth);
      this.selectMainPageMonthKey = config.key;
      this.selectMainPageMonth = config.textOption;
      this.optionsMainPageMonthName = config.optionNames;
      this.optionsMainPageMonth = config.options;
      this.newLabels = config.labels;
      this.newLabelsfulldate = config.fullLabels;
      this.activeWhere = config.activeWhere;
      return config;
    },
    applyModalPeriodConfig(optMonth) {
      const config = this.buildPeriodConfig(optMonth);
      this.selectModalMonthKey = config.key;
      this.selectModalMonth = config.textOption;
      this.optionsModalMonthName = config.optionNames;
      this.optionsModalMonth = config.options;
      this.newLabelsModal = config.labels;
      this.newLabelsModalfulldate = config.fullLabels;
      this.activeWhereModal = config.activeWhere;
      return config;
    },
    async initializeTeamsView() {
      this.teamsViewReady = false;
      this.loadingMainData = true;
      this.selectTeam = this.getInitialTeamSelection();
      this.applyMainPeriodConfig(this.getInitialMainPeriodKey());
      this.applyModalPeriodConfig(this.selectMainPageMonthKey);
      this.$store.commit("teams/setDataTable", []);
      this.$store.commit("teams/setDataTableModal", []);

      const teamsState = this.$store.state.teams;
      const metadataLoads = [];

      if (!teamsState.teamAll || teamsState.teamAll.length === 0) {
        metadataLoads.push(this.$store.dispatch("teams/getTeamArr", this.user));
      }
      if (!teamsState.impactRating || Object.keys(teamsState.impactRating).length === 0) {
        metadataLoads.push(
          this.$store.dispatch("teams/getTeamOrganization1level", this.user)
        );
      }
      if (!teamsState.organizations || Object.keys(teamsState.organizations).length === 0) {
        metadataLoads.push(this.$store.dispatch("teams/getOrganization"));
      }
      if (!this.optionsTeam || this.optionsTeam.length === 0) {
        metadataLoads.push(this.$store.dispatch("team/getTeams", this.user));
      }
      if (!this.questionsName || Object.keys(this.questionsName).length === 0) {
        metadataLoads.push(this.$store.dispatch("dashboard/getQuestionsName"));
      }
      if (
        !teamsState.insightteamsByComp ||
        teamsState.insightteamsByComp.length === 0
      ) {
        metadataLoads.push(this.$store.dispatch("teams/getInsightTeamsByComp"));
      }

      await Promise.all(metadataLoads);
      await this.refreshMainScope(this.selectTeam);
      this.setDefault();
      this.teamsViewReady = true;
    },
    async refreshMainScope(key = this.selectTeam) {
      const selectedTeam = key || this.getDefaultTeamSelection();
      const requestId = this.nextMainScopeRequestId();
      const chartRequestId = this.nextMainChartRequestId();
      const team = selectedTeam !== "all" ? selectedTeam : "";

      this.teamStatusChanged = true;
      this.dataMainPageChanged = true;
      this.loadingMainData = true;
      this.selectTeam = selectedTeam;
      this.modalTitle = selectedTeam;
      this.mainTableDataReady = false;
      this.realDataMainTreeTable = [];
      this.$store.commit("teams/setChartHappyRisk", []);
      this.$store.commit("teams/setDataTable", []);
      this.$store.commit("teams/setTeam", selectedTeam);
      this.resetMainTableExpansion();

      await this.$store.dispatch("teams/getInsightTeams", {
        selectTeam: team,
        requestKey: requestId,
      });

      await Promise.all([
        this.$store.dispatch("teams/getOverviewWeeklyActive", {
          selectTeam: selectedTeam,
          requestKey: requestId,
        }),
        this.$store.dispatch("teams/getOverviewWeeklyHealth", {
          selectTeam: team,
          requestKey: requestId,
        }),
        this.$store.dispatch("teams/getDataTablebyTeam", {
          team,
          type: "parent",
          requestKey: requestId,
        }),
        this.$store.dispatch("teams/searchSpotlightByTeam", {
          selectTeam: team,
          requestKey: requestId,
        }),
        this.refreshMainChart(chartRequestId),
      ]);

      if (requestId !== this.mainScopeRequestId) {
        return;
      }

      this.loadingMainData = false;
    },
    refreshMainChart(requestKey = null) {
      const chartRequestId = requestKey || this.nextMainChartRequestId();
      if (!this.optionsMainPageMonth.length) {
        this.$store.commit("teams/setChartHappyRisk", []);
        this.$store.commit("teams/setLoadingData", false);
        return Promise.resolve();
      }

      this.$store.commit("teams/setChartHappyRisk", []);
      this.$store.commit("teams/setSelectMonth", this.optionsMainPageMonth);
      return this.$store.dispatch("teams/getDataChart", {
        value: this.optionsMainPageMonth,
        activeWhere: this.activeWhere,
        requestKey: chartRequestId,
      });
    },
    async refreshModalScope(key) {
      const selectedTeam = key || this.selectTeam || this.getDefaultTeamSelection();
      const requestId = this.nextModalScopeRequestId();
      const chartRequestId = this.nextModalChartRequestId();
      const team = selectedTeam !== "all" ? selectedTeam : "";

      this.loadingModalData = true;
      this.selectTeamModal = selectedTeam;
      this.modalTitle = selectedTeam;
      this.modalTableDataReady = false;
      this.realDataModalTreeTable = [];
      this.$store.commit("teams/setLoadingDataModal", true);
      this.$store.commit("teams/setChartHappyRiskModal", []);
      this.$store.commit("teams/setDataTableModal", []);
      this.$store.commit("teams/setTeamModal", selectedTeam);
      this.resetModalTableExpansion();

      await this.$store.dispatch("teams/getInsightTeamsModal", {
        selectTeam: team,
        requestKey: requestId,
      });

      await Promise.all([
        this.refreshModalChart(chartRequestId),
        this.$store.dispatch("teams/fetchDimensionTrends", {
          activeWhere: this.activeWhereModal,
          requestKey: chartRequestId,
        }),
        this.$store.dispatch("teams/getDataTablebyTeamModal", {
          team,
          type: "parent",
          requestKey: requestId,
        }),
      ]);

      if (requestId !== this.modalScopeRequestId) {
        return;
      }

      this.loadingModalData = false;
    },
    refreshModalChart(requestKey = null) {
      const chartRequestId = requestKey || this.nextModalChartRequestId();
      if (!this.optionsModalMonth.length) {
        this.$store.commit("teams/setChartHappyRiskModal", []);
        this.$store.commit("teams/setLoadingDataModal", false);
        return Promise.resolve();
      }

      this.$store.commit("teams/setChartHappyRiskModal", []);
      this.$store.commit("teams/setSelectMonthModal", this.optionsModalMonth);
      return this.$store.dispatch("teams/getDataChartModal", {
        value: this.optionsModalMonth,
        activeWhere: this.activeWhereModal,
        requestKey: chartRequestId,
      });
    },
    setDefault() {
      this.mostengageMain = this.mostengage;
    },
    calculateAllTeamsMetrics() {
      if (!this.datalist || this.datalist.length === 0) {
        return {
          retentionRate: null,
          avgImpact: null,
          teamSize: null,
          happinessScore: null,
          riskScore: null,
          retentionTrend: 0,
          impactTrend: 0,
          sizeTrend: 0,
          happinessTrend: 0,
          riskTrend: 0
        };
      }

      let totalRetentionSum = 0;
      let totalDebiSum = 0;
      let totalHappiness = 0;
      let totalRisk = 0;
      let activeUserRate = null;
      let validRetentionCount = 0;
      let validDebiCount = 0;
      let validHappinessCount = 0;
      let validRiskCount = 0;

      this.datalist.forEach(team => {
        if (team.retention_rate && team.retention_rate !== '-') {
          totalRetentionSum += parseFloat(team.retention_rate);
          validRetentionCount++;
        }
        if (team.engagement_score !== undefined && !isNaN(team.engagement_score) && team.engagement_score !== null) {
          totalDebiSum += parseFloat(team.engagement_score);
          validDebiCount++;
        }
      });

      // Weekly happiness and risk from cached 13-week series
      if (this.overviewWeeklyHealth && this.overviewWeeklyHealth.happy && this.overviewWeeklyHealth.risk) {
        const wHappy = this.overviewWeeklyHealth.happy.filter(val => val > 0)
        const wRisk = this.overviewWeeklyHealth.risk.filter(val => val !== 0 && val !== null && val !== undefined)
        if (wHappy.length > 0) {
          totalHappiness = wHappy.length > 1 ? wHappy[wHappy.length - 2] : wHappy[wHappy.length - 1]
          validHappinessCount = 1
        }
        if (wRisk.length > 0) {
          totalRisk = Math.abs(wRisk.length > 1 ? wRisk[wRisk.length - 2] : wRisk[wRisk.length - 1])
          validRiskCount = 1
        }
      }

      // If the current selection is weekly and chart data is present, align card values exactly with chart (last complete week)
      if (this.activeWhere && this.activeWhere.type === 'weeks' && this.datachart && this.datachart.happy && this.datachart.risk) {
        const len = Math.min(this.datachart.happy.length, this.datachart.risk.length)
        if (len > 0) {
          const idx = len > 1 ? len - 2 : len - 1
          const chartHappy = this.datachart.happy[idx]
          const chartRisk = Math.abs(this.datachart.risk[idx])
          if (chartHappy !== null && chartHappy !== undefined) totalHappiness = chartHappy
          if (chartRisk !== null && chartRisk !== undefined) totalRisk = chartRisk
          validHappinessCount = 1
          validRiskCount = 1
        }
      }

      // Always compute Weekly Active Users from the cached 13-week series
      if (this.overviewWeeklyActive && this.overviewWeeklyActive.activeuser && this.overviewWeeklyActive.activeuser.length > 0) {
        const weekly = this.overviewWeeklyActive.activeuser.filter(v => v > 0);
        if (weekly.length > 0) {
          activeUserRate = weekly.length > 1 ? weekly[weekly.length - 2] : weekly[weekly.length - 1];
        }
      }
      return {
        retentionRate: validRetentionCount > 0 ? Math.round(totalRetentionSum / validRetentionCount) : null,
        debiScore: validDebiCount > 0 ? Math.round((totalDebiSum / validDebiCount) * 10) / 10 : null,
        activeUserRate: activeUserRate,
        happinessScore: validHappinessCount > 0 ? Math.round(totalHappiness) : null,
        riskScore: validRiskCount > 0 ? Math.round(totalRisk) : null,
        // Calculate trends from historical data arrays
        happinessTrend: this.calculateTrendFromWeeklyHealth('happiness'),
        activeUserTrend: this.calculateTrendFromWeeklyCache('activeUsers'),
        riskTrend: this.calculateTrendFromWeeklyHealth('risk'),
        // These metrics don't have historical arrays, so no trend
        retentionTrend: null,
        debiTrend: null
      };
    },
    calculateTeamMetrics(teamId) {
      if (!teamId || !this.datalist) {
        return {
          retentionRate: null,
          debiScore: null,
          activeUserRate: null,
          happinessScore: null,
          riskScore: null
        };
      }

      const team = this.datalist.find(t => t.id === teamId);
      if (!team) {
        return this.calculateAllTeamsMetrics(); // Fallback to all teams
      }

      // Calculate individual team metrics
      let activeUserRate = null;
      let happinessScore = null;
      let riskScore = null;

      // Weekly happiness and risk for single team from cached 13-week series
      if (this.overviewWeeklyHealth && this.overviewWeeklyHealth.happy && this.overviewWeeklyHealth.risk) {
        const wHappy = this.overviewWeeklyHealth.happy.filter(val => val > 0)
        const wRisk = this.overviewWeeklyHealth.risk.filter(val => val !== 0 && val !== null && val !== undefined)
        if (wHappy.length > 0) {
          happinessScore = Math.round(wHappy.length > 1 ? wHappy[wHappy.length - 2] : wHappy[wHappy.length - 1])
        }
        if (wRisk.length > 0) {
          riskScore = Math.round(Math.abs(wRisk.length > 1 ? wRisk[wRisk.length - 2] : wRisk[wRisk.length - 1]))
        }
      }

      // If viewing weekly and chart has data, align card values with chart's last complete week
      if (this.activeWhere && this.activeWhere.type === 'weeks' && this.datachart && this.datachart.happy && this.datachart.risk) {
        const len = Math.min(this.datachart.happy.length, this.datachart.risk.length)
        if (len > 0) {
          const idx = len > 1 ? len - 2 : len - 1
          const chartHappy = this.datachart.happy[idx]
          const chartRisk = Math.abs(this.datachart.risk[idx])
          if (chartHappy !== null && chartHappy !== undefined) happinessScore = Math.round(chartHappy)
          if (chartRisk !== null && chartRisk !== undefined) riskScore = Math.round(chartRisk)
        }
      }

      // Always compute Weekly Active Users from cached weekly series
      if (this.overviewWeeklyActive && this.overviewWeeklyActive.activeuser && this.overviewWeeklyActive.activeuser.length > 0) {
        const weekly = this.overviewWeeklyActive.activeuser.filter(v => v > 0);
        if (weekly.length > 0) {
          activeUserRate = weekly.length > 1 ? weekly[weekly.length - 2] : weekly[weekly.length - 1];
        }
      }
      
      return {
        retentionRate: team.retention_rate && team.retention_rate !== '-' ? Math.round(parseFloat(team.retention_rate)) : null,
        debiScore: team.engagement_score !== undefined && !isNaN(team.engagement_score) && team.engagement_score !== null ? Math.round(parseFloat(team.engagement_score) * 10) / 10 : null,
        activeUserRate: activeUserRate,
        happinessScore: happinessScore,
        riskScore: riskScore,
        // Calculate trends from chart data (same arrays used for team-specific views)
        happinessTrend: this.calculateTrendFromWeeklyHealth('happiness'),
        activeUserTrend: this.calculateTrendFromWeeklyCache('activeUsers'),
        riskTrend: this.calculateTrendFromWeeklyHealth('risk'),
        // These metrics don't have historical arrays, so no trend
        retentionTrend: null,
        debiTrend: null
      };
    },
    calculateTrendFromArray(dataArray, metricType) {
      // Return null if no data array or insufficient data points
      if (!dataArray || !Array.isArray(dataArray) || dataArray.length < 2) {
        return null;
      }

      // Filter out invalid values (0, null, undefined, negative values for non-risk metrics)
      const validData = dataArray.filter(val => {
        if (val === null || val === undefined) return false;
        if (metricType === 'risk') {
          // For risk, we want any non-zero values (positive or negative)
          return val !== 0;
        } else {
          // For happiness and activeUsers, we want positive values only
          return val > 0;
        }
      });

      if (validData.length < 2) {
        return null;
      }

      // Get the appropriate data points for comparison
      let currentValue, previousValue;

      if (metricType === 'activeUsers') {
        // For active users, use appropriate comparison based on data type
        if (!this.datachart || !this.datachart.alluser || this.datachart.alluser.length === 0) {
          return null;
        }

        let currentIndex, previousIndex;

        if (this.activeWhere && this.activeWhere.type === 'weeks') {
          // Weekly data - compare last complete week with previous week
          if (validData.length >= 3) {
            currentIndex = dataArray.length - 2; // Last complete week
            previousIndex = dataArray.length - 3; // Week before that
          } else if (validData.length === 2) {
            currentIndex = dataArray.length - 1;
            previousIndex = dataArray.length - 2;
          } else {
            return null;
          }
        } else {
          // Daily data - compare most recent complete days
          if (validData.length >= 3) {
            currentIndex = dataArray.length - 2; // Yesterday
            previousIndex = dataArray.length - 3; // Day before yesterday
          } else if (validData.length === 2) {
            currentIndex = dataArray.length - 1;
            previousIndex = dataArray.length - 2;
          } else {
            return null;
          }
        }

        // Calculate percentages for both periods
        const currentActive = dataArray[currentIndex];
        const previousActive = dataArray[previousIndex];
        const currentTotal = this.datachart.alluser[Math.min(currentIndex, this.datachart.alluser.length - 1)];
        const previousTotal = this.datachart.alluser[Math.min(previousIndex, this.datachart.alluser.length - 1)];

        if (currentTotal <= 0 || previousTotal <= 0) {
          return null;
        }

        currentValue = (currentActive / currentTotal) * 100;
        previousValue = (previousActive / previousTotal) * 100;
      } else {
        // For other metrics, use the standard last two values
        currentValue = validData[validData.length - 1];
        previousValue = validData[validData.length - 2];
      }

      // Handle risk values (stored as negative, need absolute values)
      const current = metricType === 'risk' ? Math.abs(currentValue) : currentValue;
      const previous = metricType === 'risk' ? Math.abs(previousValue) : previousValue;

      if (previous === 0) return null;

      // For percentage-based metrics (happiness, risk, activeUsers), use percentage points
      // For other metrics (like DEBI score), use percentage change
      if (['happiness', 'risk', 'activeUsers', 'retention'].includes(metricType)) {
        // Calculate percentage points (direct difference)
        const pointsChange = current - previous;
        // For risk, lower is better so invert the sign
        if (metricType === 'risk') {
          return Math.round(-pointsChange);
        }
        return Math.round(pointsChange);
      } else {
        // Calculate percentage change: ((current - previous) / previous) * 100
        const percentChange = ((current - previous) / previous) * 100;
        return Math.round(percentChange);
      }
    },
    getHealthLabel(metricType, value) {
      if (value === null || value === undefined || value === '-') {
        return { label: 'No Data', cssClass: 'health-no-data' };
      }

      const val = parseFloat(value);

      switch (metricType) {
        case 'retention':
          if (val >= 90) return { label: 'Excellent', cssClass: 'health-excellent' };
          if (val >= 80) return { label: 'Good', cssClass: 'health-good' };
          if (val >= 70) return { label: 'Needs Attention', cssClass: 'health-needs-attention' };
          return { label: 'Critical', cssClass: 'health-critical' };

        case 'impact':
          if (val >= 30) return { label: 'Excellent', cssClass: 'health-excellent' };
          if (val >= 20) return { label: 'Good', cssClass: 'health-good' };
          if (val >= 10) return { label: 'Needs Attention', cssClass: 'health-needs-attention' };
          return { label: 'Critical', cssClass: 'health-critical' };

        case 'debi':
          if (val >= 80) return { label: 'Excellent', cssClass: 'health-excellent' };
          if (val >= 60) return { label: 'Good', cssClass: 'health-good' };
          if (val >= 40) return { label: 'Needs Attention', cssClass: 'health-needs-attention' };
          return { label: 'Critical', cssClass: 'health-critical' };

        case 'activeUsers':
          if (val >= 80) return { label: 'Excellent', cssClass: 'health-excellent' };
          if (val >= 60) return { label: 'Good', cssClass: 'health-good' };
          if (val >= 40) return { label: 'Needs Attention', cssClass: 'health-needs-attention' };
          return { label: 'Critical', cssClass: 'health-critical' };

        case 'happiness':
          if (val >= 75) return { label: 'Excellent', cssClass: 'health-excellent' };
          if (val >= 60) return { label: 'Good', cssClass: 'health-good' };
          if (val >= 40) return { label: 'Needs Attention', cssClass: 'health-needs-attention' };
          return { label: 'Critical', cssClass: 'health-critical' };

        case 'risk':
          if (val < 5) return { label: 'Excellent', cssClass: 'health-excellent' };
          if (val < 15) return { label: 'Good', cssClass: 'health-good' };
          if (val < 25) return { label: 'Needs Attention', cssClass: 'health-needs-attention' };
          return { label: 'Critical', cssClass: 'health-critical' };

        default:
          return { label: 'Unknown', cssClass: 'health-no-data' };
      }
    },

    getProgressBarStyle(metricType, value) {
      if (value === null || value === undefined || value === '-') {
        return {
          width: '0%',
          backgroundColor: '#E0E0E0'
        };
      }

      const val = parseFloat(value);
      let percentage = 0;
      let color = '#E0E0E0';

      switch (metricType) {
        case 'retention':
          // Scale retention from 70-100% range for more intuitive visualization
          // Values below 70% are critically low, so we scale within meaningful range
          const minRetention = 70;
          const maxRetention = 100;
          const clampedVal = Math.max(minRetention, Math.min(val, maxRetention));
          percentage = ((clampedVal - minRetention) / (maxRetention - minRetention)) * 100;
          if (val >= 95) color = '#1AC362';
          else if (val >= 90) color = '#6BCF7F';
          else if (val >= 85) color = '#F7B924';
          else color = '#F44336';
          break;

        case 'impact':
          percentage = Math.min(100, (val / 40) * 100); // Scale to 40 as max
          if (val >= 30) color = '#1AC362';
          else if (val >= 20) color = '#6BCF7F';
          else if (val >= 10) color = '#F7B924';
          else color = '#F44336';
          break;

        case 'debi':
          percentage = Math.min(100, val);
          if (val >= 75) color = '#1AC362';
          else if (val >= 50) color = '#6BCF7F';
          else if (val >= 40) color = '#F7B924';
          else color = '#F44336';
          break;

        case 'activeUsers':
          percentage = Math.min(100, val);
          if (val >= 70) color = '#1AC362';
          else if (val >= 60) color = '#6BCF7F';
          else if (val >= 40) color = '#F7B924';
          else color = '#F44336';
          break;

        case 'happiness':
          percentage = Math.min(100, val);
          if (val >= 75) color = '#1AC362';
          else if (val >= 60) color = '#6BCF7F';
          else if (val >= 40) color = '#F7B924';
          else color = '#F44336';
          break;

        case 'risk':
          // Scale risk from 0-30% range for better visualization of high risk scenarios
          // Higher risk shows more filled bar (danger indicator)
          const maxRisk = 30;
          const clampedRisk = Math.min(val, maxRisk);
          percentage = (clampedRisk / maxRisk) * 100;
          if (val < 3) color = '#1AC362';
          else if (val < 5) color = '#6BCF7F';
          else if (val < 7) color = '#F7B924';
          else color = '#F44336';
          break;

        default:
          percentage = 0;
          color = '#E0E0E0';
      }

      return {
        width: `${percentage}%`,
        backgroundColor: color
      };
    },

    showTooltip(metricType, event) {
      const value = this.getMetricValue(metricType);
      this.tooltipContent = this.getTooltipContent(metricType, value);

      // Position tooltip
      const rect = event.target.getBoundingClientRect();
      this.tooltipStyle = {
        position: 'fixed',
        left: `${rect.left}px`,
        top: `${rect.bottom + 8}px`,
        zIndex: 1000
      };

      this.tooltipVisible = true;
    },

    hideTooltip() {
      this.tooltipVisible = false;
    },

    getMetricValue(metricType) {
      if (!this.teamMetrics) return null;

      switch (metricType) {
        case 'happiness': return this.teamMetrics.happinessScore;
        case 'risk': return this.teamMetrics.riskScore;
        case 'activeUsers': return this.teamMetrics.activeUserRate;
        case 'debi': return this.teamMetrics.debiScore;
        case 'retention': return this.teamMetrics.retentionRate;
        default: return null;
      }
    },

    getTooltipContent(metricType, value) {
      if (value === null || value === undefined || value === '-') {
        return this.getNoDataTooltip(metricType);
      }

      const val = parseFloat(value);
      const healthInfo = this.getHealthLevel(metricType, val);

      switch (metricType) {
        case 'happiness':
          return `
            <div class="tooltip-header">Team Happiness</div>
            <div class="tooltip-value">${val}% - ${healthInfo.label}</div>
            <div class="tooltip-description">
              Measures overall team satisfaction and wellbeing based on survey responses.
              ${this.getHealthInsight('happiness', val)}
            </div>
            ${this.getTrendInsight('happiness')}
          `;

        case 'risk':
          return `
            <div class="tooltip-header">Risk Level</div>
            <div class="tooltip-value">${val}% - ${healthInfo.label}</div>
            <div class="tooltip-description">
              Indicates potential team health issues and likelihood of turnover.
              ${this.getHealthInsight('risk', val)}
            </div>
            ${this.getTrendInsight('risk')}
          `;

        case 'activeUsers':
          return `
            <div class="tooltip-header">Weekly Active Users</div>
            <div class="tooltip-value">${val}% - ${healthInfo.label}</div>
            <div class="tooltip-description">
              Percentage of team members actively engaged in the last complete week.
              ${this.getHealthInsight('activeUsers', val)}
            </div>
            ${this.getTrendInsight('activeUsers')}
          `;

        case 'debi':
          return `
            <div class="tooltip-header">Engagement (DEBI)</div>
            <div class="tooltip-value">${val} - ${healthInfo.label}</div>
            <div class="tooltip-description">
              Daily Engagement and Behavior Index - measures daily team participation.
              ${this.getHealthInsight('debi', val)}
            </div>
          `;

        case 'retention':
          return `
            <div class="tooltip-header">6-Month Retention</div>
            <div class="tooltip-value">${val}% - ${healthInfo.label}</div>
            <div class="tooltip-description">
              Percentage of team members who stayed for at least 6 months.
              ${this.getHealthInsight('retention', val)}
            </div>
          `;

        default:
          return '<div class="tooltip-description">Metric information unavailable</div>';
      }
    },

    getNoDataTooltip(metricType) {
      const descriptions = {
        happiness: 'Team Happiness data is not available. This could be due to insufficient survey responses or recent team changes.',
        risk: 'Risk Level data is not available. May indicate new team or insufficient historical data.',
        activeUsers: 'Weekly Active Users data is not available. Try selecting a weekly duration (13-weeks, 26-weeks, or 52-weeks).',
        debi: 'Engagement (DEBI) data is not available. This requires daily engagement data.',
        retention: '6-Month Retention data is not available. May indicate new team members or insufficient historical data.'
      };

      return `
        <div class="tooltip-header">No Data Available</div>
        <div class="tooltip-description">${descriptions[metricType] || 'Data not available'}</div>
      `;
    },

    getHealthLevel(metricType, val) {
      switch (metricType) {
        case 'retention':
          if (val >= 95) return { label: 'Excellent' };
          if (val >= 90) return { label: 'Good' };
          if (val >= 85) return { label: 'Okay' };
          return { label: 'Needs Attention' };

        case 'debi':
          if (val >= 75) return { label: 'Excellent' };
          if (val >= 50) return { label: 'Good' };
          if (val >= 40) return { label: 'Okay' };
          return { label: 'Needs Attention' };

        case 'activeUsers':
          if (val >= 70) return { label: 'Excellent' };
          if (val >= 60) return { label: 'Good' };
          if (val >= 40) return { label: 'Okay' };
          return { label: 'Needs Attention' };

        case 'happiness':
          if (val >= 75) return { label: 'Excellent' };
          if (val >= 60) return { label: 'Good' };
          if (val >= 40) return { label: 'Okay' };
          return { label: 'Needs Attention' };

        case 'risk':
          if (val < 3) return { label: 'Excellent' };
          if (val < 5) return { label: 'Good' };
          if (val < 7) return { label: 'Okay' };
          return { label: 'Needs Attention' };

        default:
          return { label: 'Unknown' };
      }
    },

    getHealthInsight(metricType, val) {
      switch (metricType) {
        case 'happiness':
          if (val >= 75) return 'Your team is highly satisfied and engaged.';
          if (val >= 60) return 'Team satisfaction is solid with room for improvement.';
          if (val >= 40) return 'Team satisfaction is okay but could be improved.';
          return 'Team satisfaction needs attention - consider team building activities.';

        case 'risk':
          if (val < 3) return 'Very low risk - team is stable and secure.';
          if (val < 5) return 'Low risk - team health is good.';
          if (val < 7) return 'Moderate risk - monitor team health closely.';
          return 'High risk - immediate intervention needed.';

        case 'activeUsers':
          if (val >= 70) return 'Excellent engagement - most team members are actively participating.';
          if (val >= 60) return 'Good engagement - majority of team is active.';
          if (val >= 40) return 'Moderate engagement - consider motivation strategies.';
          return 'Low engagement - team participation needs improvement.';

        case 'debi':
          if (val >= 75) return 'Strong daily engagement across the team.';
          if (val >= 50) return 'Good daily participation levels.';
          if (val >= 40) return 'Daily engagement could be improved.';
          return 'Low daily engagement - consider daily check-ins.';

        case 'retention':
          if (val >= 95) return 'Excellent retention - team members are staying long-term.';
          if (val >= 90) return 'Good retention with stable team composition.';
          if (val >= 85) return 'Moderate retention - monitor team health.';
          return 'Low retention - investigate causes of turnover.';

        default:
          return '';
      }
    },

    getTrendInsight(metricType) {
      const trend = this.getTrendValue(metricType);
      if (trend === null) return '';

      const isImproving = (metricType === 'risk') ? trend < 0 : trend > 0;
      const direction = isImproving ? 'improving' : 'declining';
      const icon = isImproving ? '📈' : '📉';

      return `
        <div class="tooltip-trend">
          ${icon} <strong>Trend:</strong> ${Math.abs(trend)} pts ${direction} since last period
        </div>
      `;
    },

    getTrendValue(metricType) {
      if (!this.teamMetrics) return null;

      switch (metricType) {
        case 'happiness': return this.teamMetrics.happinessTrend;
        case 'risk': return this.teamMetrics.riskTrend;
        case 'activeUsers': return this.teamMetrics.activeUserTrend;
        default: return null;
      }
    },

    randerMainPageChart() {
      var chart = this.$refs.chartCurrent;
      var ctx = chart.getContext("2d");
      if (this.expandProps.navCall && this.myChart) {
        this.myChart.destroy();
      }
      if ((this.dataMainPageChanged && this.datachart.happy) || this.expandProps.navCall) {
        let maxRiskLevel = -20;
        for (let i = 0; i < this.datachart.risk.length; i++) {
          if (this.datachart.risk[i] > 0) {
            this.datachart.risk[i] = this.datachart.risk[i] * -1;
          }
          if (this.datachart.risk[i] < maxRiskLevel) {
            maxRiskLevel = this.datachart.risk[i];
          }
        }
        const backgroundColorBar = [];
        const borderColorBar = [];
        for (let i = 0; i < this.datachart.activeuser.length; i++) {
          if (this.datachart.happy[i] === 0 && this.datachart.risk[i] === 0) {
            this.datachart.happy[i] = 2;
            borderColorBar.push("#747474");
            backgroundColorBar.push("#747474");
          } else {
            borderColorBar.push("#3AC47D");
            backgroundColorBar.push("#3AC47D");
          }
        }
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        options.scales = {
          y: {
            stacked: true,
            max: 100,
            min: maxRiskLevel,
            ticks: {
              display: true,
              stepSize: 100,
              callback: function (value) {
                return value + "%";
              },
            },
            grid: {
              display: false,
            },
          },
          x: {
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              autoSkip: false,
            },
          },
        };
        options.datasets = {
          bar: {
            categoryPercentage: 0.8,
            borderRadius: 4,
            borderSkipped: false,
          },
        };
        options.plugins.tooltip = {
          mode: "index",
          position: "nearest",
          callbacks: {
            title: (tooltipItems) => {
              return "Date: " + this.newLabels[tooltipItems[0].dataIndex];
            },
            label: function (tooltipItems) {
              const label = tooltipItems.dataset.label;
              let value = tooltipItems.formattedValue;
              if (value < 0) {
                value = value * -1;
              }
              if (tooltipItems.datasetIndex == 0) {
                const people =
                  tooltipItems.dataset.allUser[tooltipItems.dataIndex];
                return `${label}: ${value}% (${people})`;
              } else if (
                tooltipItems.datasetIndex == 1 &&
                tooltipItems.dataset.backgroundColor[tooltipItems.dataIndex] ==
                  "#747474"
              ) {
                value = "0";
              }
              return `${label}: ${value}%`;
            },
          },
        };
        this.myChart = new Chart(ctx, {
          type: "line",
          data: {
            labels: this.optionsMainPageMonthName,
            datasets: [
              {
                label: this.$t("insights.ACTIVE_USERS"),
                data: this.datachart.activeuser,
                allUser: this.datachart.alluser,
                backgroundColor: "#6C30CC",
                borderColor: "#6C30CC",
                stack: "combined",
                borderWidth: 2.5,
                pointRadius: 0,
                pointBorderWidth: 0,
              },
              {
                label: this.$t("insights.HAPPINESS"),
                data: this.datachart.happy,
                backgroundColor: (context) => {
                  if (!context.chart.chartArea) return backgroundColorBar;
                  const { ctx, chartArea } = context.chart;
                  const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
                  gradient.addColorStop(0, 'rgba(58, 196, 125, 0.65)');
                  gradient.addColorStop(0.5, 'rgba(58, 196, 125, 0.75)');
                  gradient.addColorStop(1, 'rgba(58, 196, 125, 0.85)');
                  return gradient;
                },
                borderColor: borderColorBar,
                borderWidth: 0,
                stack: "combined",
                type: "bar",
                stack: "Stack 0",
              },
              {
                label: this.$t("insights.RISK"),
                data: this.datachart.risk,
                backgroundColor: (context) => {
                  if (!context.chart.chartArea) return 'rgba(244, 67, 54, 0.75)';
                  const { ctx, chartArea } = context.chart;
                  const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
                  gradient.addColorStop(0, 'rgba(244, 67, 54, 0.85)');
                  gradient.addColorStop(0.5, 'rgba(244, 67, 54, 0.75)');
                  gradient.addColorStop(1, 'rgba(244, 67, 54, 0.65)');
                  return gradient;
                },
                borderColor: "#F44336",
                borderWidth: 0,
                stack: "combined",
                type: "bar",
                stack: "Stack 0",
              },
            ],
          },
          options: options,
        });
        this.dataMainPageChanged = false;
      }
    },
    randerBarChartModal() {
      let maxRiskLevel = -20;
      var chart = this.$refs.chartBarModal;
      if (chart) {
        if (this.dataBarChartModal.risk) {
          for (let i = 0; i < this.dataBarChartModal.risk.length; i++) {
            if (this.dataBarChartModal.risk[i] > 0) {
              this.dataBarChartModal.risk[i] =
                this.dataBarChartModal.risk[i] * -1;
            }
            if (this.dataBarChartModal.risk[i] < maxRiskLevel) {
              maxRiskLevel = this.dataBarChartModal.risk[i];
            }
          }
        }
        const backgroundColorBar = [];
        const borderColorBar = [];
        for (let i = 0; i < this.dataBarChartModal.activeuser.length; i++) {
          if (
            this.dataBarChartModal.happy[i] === 0 &&
            this.dataBarChartModal.risk[i] === 0
          ) {
            this.dataBarChartModal.happy[i] = 2;
            borderColorBar.push("#747474");
            backgroundColorBar.push("#747474");
          } else {
            borderColorBar.push("#3AC47D");
            backgroundColorBar.push("#3AC47D");
          }
        }
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        options.scales = {
          y: {
            stacked: true,
            max: 100,
            min: maxRiskLevel,
            ticks: {
              display: true,
              stepSize: 100,
              callback: function (value) {
                return value + "%";
              },
            },
            grid: {
              display: false,
            },
          },
          x: {
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              autoSkip: false,
            },
          },
        };
        options.datasets = {
          bar: {
            categoryPercentage: 0.8,
            borderRadius: 4,
            borderSkipped: false,
          },
        };
        options.plugins.tooltip = {
          mode: "index",
          position: "nearest",
          callbacks: {
            title: (tooltipItems) => {
              return "Date: " + this.newLabelsModal[tooltipItems[0].dataIndex];
            },
            label: function (tooltipItems) {
              const label = tooltipItems.dataset.label;
              let value = tooltipItems.formattedValue;
              if (value < 0) {
                value = value * -1;
              }
              if (tooltipItems.datasetIndex == 0) {
                const people =
                  tooltipItems.dataset.allUser[tooltipItems.dataIndex];
                return `${label}: ${value}% (${people})`;
              } else if (
                tooltipItems.datasetIndex == 1 &&
                tooltipItems.dataset.backgroundColor[tooltipItems.dataIndex] ==
                  "#747474"
              ) {
                value = "0";
              }
              return `${label}: ${value}%`;
            },
          },
        };
        // this.loadingModalChartStatus = false;
        var ctx = chart.getContext("2d");
        this.myModalBarChart = new Chart(ctx, {
          type: "line",
          data: {
            labels: this.optionsModalMonthName,
            datasets: [
              {
                label: this.$t("insights.ACTIVE_USERS"),
                data: this.dataBarChartModal.activeuser,
                allUser: this.dataBarChartModal.alluser,
                backgroundColor: "#6C30CC",
                borderColor: "#6C30CC",
                stack: "combined",
                borderWidth: 2.5,
                pointBorderWidth: 1,
                pointHoverRadius: 0,
                pointRadius: 0,
              },
              {
                label: this.$t("insights.HAPPINESS"),
                data: this.dataBarChartModal.happy,
                backgroundColor: (context) => {
                  if (!context.chart.chartArea) return backgroundColorBar;
                  const { ctx, chartArea } = context.chart;
                  const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
                  gradient.addColorStop(0, 'rgba(58, 196, 125, 0.65)');
                  gradient.addColorStop(0.5, 'rgba(58, 196, 125, 0.75)');
                  gradient.addColorStop(1, 'rgba(58, 196, 125, 0.85)');
                  return gradient;
                },
                borderColor: borderColorBar,
                borderWidth: 0,
                stack: "combined",
                type: "bar",
                stack: "Stack 0",
              },
              {
                label: this.$t("insights.RISK"),
                data: this.dataBarChartModal.risk,
                backgroundColor: (context) => {
                  if (!context.chart.chartArea) return 'rgba(244, 67, 54, 0.75)';
                  const { ctx, chartArea } = context.chart;
                  const gradient = ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom);
                  gradient.addColorStop(0, 'rgba(244, 67, 54, 0.85)');
                  gradient.addColorStop(0.5, 'rgba(244, 67, 54, 0.75)');
                  gradient.addColorStop(1, 'rgba(244, 67, 54, 0.65)');
                  return gradient;
                },
                borderColor: "#F44336",
                borderWidth: 0,
                stack: "combined",
                type: "bar",
                stack: "Stack 0",
              },
            ],
          },
          options: options,
        });
        this.chartInModalNodataStatus = false; // Show UI no data on here!
      } else {
        // this.loadingModalChartStatus = false;
      }
    },
    remoteMainPage(rows, callback) {
      setTimeout(() => {
        var response = [];
        if (this.selectMainPageSort == "1") {
          response = _.orderBy(
            rows.children,
            [
              function (o) {
                return o.happirate;
              },
            ],
            ["desc"]
          );
        } else if (this.selectMainPageSort == "2") {
          response = _.orderBy(
            rows.children,
            [
              function (o) {
                return o.riskrate;
              },
            ],
            ["asc"]
          );
        } else if (this.selectMainPageSort == "3") {
          response = _.orderBy(
            rows.children,
            [
              function (o) {
                return o.riskrate;
              },
            ],
            ["desc"]
          );
        } else {
          response = _.orderBy(
            rows.children,
            [
              function (o) {
                return o.happirate;
              },
            ],
            ["asc"]
          );
        }
        callback(response);
      }, 300);
    },
    remoteModal(rows, callback) {
      setTimeout(() => {
        var response = [];
        if (this.selectModalSort == "1") {
          response = _.orderBy(
            rows.children,
            [
              function (o) {
                return o.happirate;
              },
            ],
            ["desc"]
          );
        } else if (this.selectModalSort == "2") {
          response = _.orderBy(
            rows.children,
            [
              function (o) {
                return o.riskrate;
              },
            ],
            ["asc"]
          );
        } else if (this.selectModalSort == "3") {
          response = _.orderBy(
            rows.children,
            [
              function (o) {
                return o.riskrate;
              },
            ],
            ["desc"]
          );
        } else {
          response = _.orderBy(
            rows.children,
            [
              function (o) {
                return o.happirate;
              },
            ],
            ["asc"]
          );
        }
        callback(response);
      }, 300);
    },
    async showModal(key) {
      this.spotlightTeamStatus = true;
      this.applyModalPeriodConfig(this.selectMainPageMonthKey);
      await this.refreshModalScope(key);
    },
    async changMainPageData(key) {
      await this.refreshMainScope(key);
    },
    async handleTeamsModal(key) {
      await this.refreshModalScope(key);
    },
    async handleTeams(key) {
      await this.refreshMainScope(key);
    },


    async handleMainPageMonth(optMonth) {
      this.dataMainPageChanged = true;
      this.applyMainPeriodConfig(optMonth);
      if (!this.teamsViewReady) {
        return;
      }
      await this.refreshMainChart();
    },
    async handleModalMonth(optMonth) {
      this.applyModalPeriodConfig(optMonth);
      if (!this.spotlightTeamStatus || !this.selectTeamModal) {
        return;
      }

      const chartRequestId = this.nextModalChartRequestId();
      await Promise.all([
        this.refreshModalChart(chartRequestId),
        this.$store.dispatch("teams/fetchDimensionTrends", {
          activeWhere: this.activeWhereModal,
          requestKey: chartRequestId,
        }),
      ]);
    },
    sortByMainPage(row) {
      this.selectMainPageSort = row.index;
      this.dataMainTreeTable();
    },
    async sortByModal(row) {
      this.selectModalSort = row.index;
      this.$store.commit("teams/setSortModal", this.selectModalSort);
      await this.handleSort(row);
      this.dataModalTreeTable();
    },
    handleSort(row) {
      this.$store.commit("teams/setDataTableModal", []);
      const team = this.selectTeamModal !== "all" ? this.selectTeamModal : "";
      const requestId = this.nextModalScopeRequestId();
      this.resetModalTableExpansion();
      return this.$store.dispatch("teams/getDataTablebyTeamModal", {
        team,
        type: "parent",
        sort: this.selectModalSort,
        requestKey: requestId,
      });
    },
    generateChartTooltipOnMainEngagement() {
      let value = this.hoverTeam
      let chart = this.$refs['engagement_'+value.id];
      if(chart){
        var tooltipBarChart = this.$refs['engagement_'+value.id];
        if (tooltipBarChart) {
          const tooltipBarchartDataResigned = {
            labels: this.databarchartEngagementScore['labels'],
            datasets: [
              {
                data: this.databarchartEngagementScore['team'],
                borderColor: "#00ACC1",
                fill: true,
                borderWidth: 2,
                borderRadius: 1,
                pointRadius: 0,
                backgroundColor: (context) => {
                    if(!context.chart.chartArea){
                      return;
                    }
                    var ctx = chart.getContext("2d");
                    let gradientFill = ctx.createLinearGradient(0, 0, 0, 175);
                    gradientFill.addColorStop(0, "#00ACC14A");
                    gradientFill.addColorStop(1, "#00ACC100");
                    return gradientFill;
                },
              },
              {
                data: this.databarchartEngagementScore['manager'],
                borderColor: "#E45006",
                fill: true,
                borderWidth: 2,
                borderRadius: 1,
                pointRadius: 0,
                backgroundColor: (context) => {
                    if(!context.chart.chartArea){
                      return;
                    }
                    var ctx = chart.getContext("2d");
                    let gradientFill = ctx.createLinearGradient(0, 0, 0, 175);
                    gradientFill.addColorStop(0, "#E450064A");
                    gradientFill.addColorStop(1, "#E4500600");
                    return gradientFill;
                },
              },
              {
                data: this.databarchartEngagementScore['leader'],
                borderColor: "#D532C2",
                fill: true,
                borderWidth: 2,
                borderRadius: 1,
                pointRadius: 0,
                backgroundColor: (context) => {
                    if(!context.chart.chartArea){
                      return;
                    }
                    var ctx = chart.getContext("2d");
                    let gradientFill = ctx.createLinearGradient(0, 0, 0, 175);
                    gradientFill.addColorStop(0, "#D532C24A");
                    gradientFill.addColorStop(1, "#D532C200");
                    return gradientFill;
                },
              },
            ],
          };
          this.barChartTooltipBarChartOnMainEngagement = new Chart(
            tooltipBarChart.getContext("2d"),
            {
              type: "line",
              data: tooltipBarchartDataResigned,
              options: {
                interaction: {
                  intersect: false,
                  mode: 'nearest'
                },
                maintainAspectRatio: false,
                scales: {
                  y: {
                    min: 0,
                    display: false,
                    ticks: {
                      stepSize: 50,
                      callback: function (value) {
                        return value;
                      },
                    },
                    grid: {
                      display: false,
                    },
                  },
                  x: {
                    ticks: {
                      autoSkip: false,
                      maxRotation: 0,
                      minRotation: 0,
                      font: {
                        color: 'black',
                        size: 12,
                        weight: 'bold',
                        family: 'Lato'
                      },
                    },
                    grid: {
                      display: false,
                    },
                  },
                },
                plugins: {
                  legend: {
                    display: false,
                  },
                  datalabels: {
                    formatter: function (value, context) {
                      return value;
                    },
                    font: {
                      weight: "bold",
                      size: 10,
                    },
                  },
                  tooltip: {
                    mode: "index",
                    position: "nearest",
                    callbacks: {
                      title: (tooltipItems) => {
                        return this.databarchartEngagementScore['newLabels'][tooltipItems[0].dataIndex];
                      },
                      label: function (tooltipItems) {
                        const value = tooltipItems.formattedValue;
                        if(tooltipItems.datasetIndex == 0){
                          return ` Overall : ${value}`;
                        }else if(tooltipItems.datasetIndex == 1){
                          return ` Manager : ${value}`;
                        }else if(tooltipItems.datasetIndex == 2){
                          return ` Leader : ${value}`;
                        }
                      },
                    },
                    titleFont: {
                      weight: 'bold',
                    },
                  },
                },
                elements: {
                  line: {
                    tension: 0,
                  },
                },
                responsive: true,
                animations: false,
              },
            }
          );
        }
      }
    },
    generateChartTooltipOnModalEngagement() {
      let value = this.hoverModalTeam
      let chart = this.$refs['engagement_modal_'+value.id];
      if(chart){
        var tooltipBarChart = this.$refs['engagement_modal_'+value.id];
        if (tooltipBarChart) {
          const tooltipBarchartDataResigned = {
            labels: this.databarchartEngagementScoreModal['labels'],
            datasets: [
              {
                data: this.databarchartEngagementScoreModal['team'],
                borderColor: "#00ACC1",
                fill: true,
                borderWidth: 2,
                borderRadius: 1,
                pointRadius: 1,
                backgroundColor: (context) => {
                    if(!context.chart.chartArea){
                      return;
                    }
                    var ctx = chart.getContext("2d");
                    let gradientFill = ctx.createLinearGradient(0, 0, 0, 175);
                    gradientFill.addColorStop(0, "#00ACC14A");
                    gradientFill.addColorStop(1, "#00ACC100");
                    return gradientFill;
                },
              },
              {
                data: this.databarchartEngagementScoreModal['manager'],
                borderColor: "#E45006",
                fill: true,
                borderWidth: 2,
                borderRadius: 1,
                pointRadius: 1,
                backgroundColor: (context) => {
                    if(!context.chart.chartArea){
                      return;
                    }
                    var ctx = chart.getContext("2d");
                    let gradientFill = ctx.createLinearGradient(0, 0, 0, 175);
                    gradientFill.addColorStop(0, "#E450064A");
                    gradientFill.addColorStop(1, "#E4500600");
                    return gradientFill;
                },
              },
              {
                data: this.databarchartEngagementScoreModal['leader'],
                borderColor: "#D532C2",
                fill: true,
                borderWidth: 2,
                borderRadius: 1,
                pointRadius: 1,
                backgroundColor: (context) => {
                    if(!context.chart.chartArea){
                      return;
                    }
                    var ctx = chart.getContext("2d");
                    let gradientFill = ctx.createLinearGradient(0, 0, 0, 175);
                    gradientFill.addColorStop(0, "#D532C24A");
                    gradientFill.addColorStop(1, "#D532C200");
                    return gradientFill;
                },
              },
            ],
          };
          this.barChartTooltipBarChartOnModalEngagement = new Chart(
            tooltipBarChart.getContext("2d"),
            {
              type: "line",
              data: tooltipBarchartDataResigned,
              options: {
                interaction: {
                  intersect: false,
                  mode: 'nearest'
                },
                maintainAspectRatio: false,
                scales: {
                  y: {
                    min: 0,
                    display: false,
                    ticks: {
                      stepSize: 50,
                      callback: function (value) {
                        return value;
                      },
                    },
                    grid: {
                      display: false,
                    },
                  },
                  x: {
                    ticks: {
                      autoSkip: false,
                      maxRotation: 0,
                      minRotation: 0,
                      font: {
                        color: 'black',
                        size: 12,
                        weight: 'bold',
                        family: 'Lato'
                      },
                    },
                    grid: {
                      display: false,
                    },
                  },
                },
                plugins: {
                  legend: {
                    display: false,
                  },
                  datalabels: {
                    formatter: function (value, context) {
                      return value;
                    },
                    font: {
                      weight: "bold",
                      size: 10,
                    },
                  },
                  tooltip: {
                    mode: "index",
                    position: "nearest",
                    callbacks: {
                      title: (tooltipItems) => {
                        return this.databarchartEngagementScoreModal['newLabels'][tooltipItems[0].dataIndex];
                      },
                      label: function (tooltipItems) {
                        const value = tooltipItems.formattedValue;
                        if(tooltipItems.datasetIndex == 0){
                          return ` Overall : ${value}`;
                        }else if(tooltipItems.datasetIndex == 1){
                          return ` Manager : ${value}`;
                        }else if(tooltipItems.datasetIndex == 2){
                          return ` Leader : ${value}`;
                        }
                      },
                    },
                    titleFont: {
                      weight: 'bold',
                    },
                  },
                },
                elements: {
                  line: {
                    tension: 0,
                  },
                },
                responsive: true,
                animations: false,
              },
            }
          );
        }
      }
    },
    generateChartTooltipOnMain(value) {
      //console.log("generateChartTooltipOnMain", value);
      if (this.barChartTooltipBarChartOnMain) {
        this.barChartTooltipBarChartOnMain.destroy();
      }
      let chartLabel = [];
             // TODO: Add data to chart here!
      let chartDataResigned = []; // TODO: Add data to chart here!
      let chartDataTerminated = []; // TODO: Add data to chart here!
      let chartDataAll = []; // TODO: Add data to chart here!
      for(let i=5;i>=0;i--){
        chartLabel.push( this.$dateFns.format(addMonths(new Date(), -i), 'MMM'))
        const dateKey=this.$dateFns.format(addMonths(new Date(), -i), 'YYYY-MM')

        chartDataResigned.push(value.resigned[dateKey]?value.resigned[dateKey]:0)
        chartDataTerminated.push(value.terminate[dateKey]?value.terminate[dateKey]:0)
        chartDataAll.push(isNaN(value.resigned[dateKey]+value.terminate[dateKey])?0:value.resigned[dateKey]+value.terminate[dateKey])
      }

      const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));

      // let type = this.getTypeOfData(this.rowSelected);
      var tooltipBarChart = this.$refs[value.id];
      // const width = (chartBarColor.length * 48 || 0) + 165;
      // this.widthOfPopup = `width: ${width}px;`;
      options.plugins.datalabels = {
        color: "#000",
        font: {
          weight: "bold",
          size: 12,
        },
        formatter: function (value, context) {
          return context.dataset.sumData[context.dataIndex];
        },
      };
      options.layout = {
        padding: {
          top: 20,
        },
      };
      options.scales = {
        y: {
          grid: {
            display: true,
            drawBorder: true,
          },
          ticks: {
            display: false,
            beginAtZero: true,
          },
          stacked: true,
        },
        x: {
          stacked: true,
        },
      };
      options.animations = false;

      if (tooltipBarChart) {
        this.loadingChartInTable = false;
        const blankAll = [];
        chartDataTerminated.forEach((item, index) => {
          if (item > 0) {
            blankAll.push("");
          } else {
            blankAll.push(chartDataAll[index]);
          }
        });
        const tooltipBarchartDataResigned = {
          labels: chartLabel,
          datasets: [
            {
              data: chartDataResigned,
              sumData: blankAll,
              backgroundColor: "#F44336",
              stack: "Stack 0",
              borderRadius: 0,
            },
            {
              data: chartDataTerminated,
              sumData: chartDataAll,
              backgroundColor: "#FFBCB7",
              stack: "Stack 0",
              borderRadius: 0,
            },
          ],
        };
        this.barChartTooltipBarChartOnMain = new Chart(
          tooltipBarChart.getContext("2d"),
          {
            plugins: [chartDataResignedLabels],
            type: "bar",
            data: tooltipBarchartDataResigned,
            options: options,
          }
        );
      }
    },
    generateChartTooltipOnModal(value) {
      if (this.barChartTooltipBarChartOnModal) {
        this.barChartTooltipBarChartOnModal.destroy();
      }

      // console.log("@TODO: Add data to chart", value);
      // let chartLabel = ["Jan", "Feb", "Mar", "Apr", "May", "Jun"]; // TODO: Add data to chart here!
      // let chartDataResigned = [6, 7, 8, 7, 5, 8]; // TODO: Add data to chart here!
      // let chartDataTerminated = [0, 2, 0, 0, 1, 2]; // TODO: Add data to chart here!
      // let chartDataAll = [6, 9, 8, 7, 6, 10]; // TODO: Add data to chart here!
      let chartLabel = [];// TODO: Add data to chart here!
      let chartDataResigned = []; // TODO: Add data to chart here!
      let chartDataTerminated = []; // TODO: Add data to chart here!
      let chartDataAll = []; // TODO: Add data to chart here!
      for(let i=5;i>=0;i--){
        chartLabel.push( this.$dateFns.format(addMonths(new Date(), -i), 'MMM'))
        const dateKey=this.$dateFns.format(addMonths(new Date(), -i), 'YYYY-MM')

        chartDataResigned.push(value.resigned[dateKey]?value.resigned[dateKey]:0)
        chartDataTerminated.push(value.terminate[dateKey]?value.terminate[dateKey]:0)
        chartDataAll.push(isNaN(value.resigned[dateKey]+value.terminate[dateKey])?0:value.resigned[dateKey]+value.terminate[dateKey])
      }

      const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));

      // let type = this.getTypeOfData(this.rowSelected);
      var tooltipBarChart = this.$refs["modal_" + value.id];
      // const width = (chartBarColor.length * 48 || 0) + 165;
      // this.widthOfPopup = `width: ${width}px;`;
      options.plugins.datalabels = {
        color: "#000",
        font: {
          weight: "bold",
          size: 12,
        },
        formatter: function (value, context) {
          return context.dataset.sumData[context.dataIndex];
        },
      };
      options.layout = {
        padding: {
          top: 20,
        },
      };
      options.scales = {
        y: {
          grid: {
            display: true,
            drawBorder: true,
          },
          ticks: {
            display: false,
            beginAtZero: true,
          },
          stacked: true,
        },
        x: {
          stacked: true,
        },
      };
      options.animations = false;

      if (tooltipBarChart) {
        this.loadingChartInTable = false;
        const blankAll = [];
        chartDataTerminated.forEach((item, index) => {
          if (item > 0) {
            blankAll.push("");
          } else {
            blankAll.push(chartDataAll[index]);
          }
        });
        const tooltipBarchartDataResigned = {
          labels: chartLabel,
          datasets: [
            {
              data: chartDataResigned,
              sumData: blankAll,
              backgroundColor: "#F44336",
              stack: "Stack 0",
              borderRadius: 0,
            },
            {
              data: chartDataTerminated,
              sumData: chartDataAll,
              backgroundColor: "#FFBCB7",
              stack: "Stack 0",
              borderRadius: 0,
            },
          ],
        };
        this.barChartTooltipBarChartOnModal = new Chart(
          tooltipBarChart.getContext("2d"),
          {
            plugins: [chartDataResignedLabels],
            type: "bar",
            data: tooltipBarchartDataResigned,
            options: options,
          }
        );
      }
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 6) {
        return `
          background-image: linear-gradient(to bottom, #6C30CC 40%, rgba(255, 255, 255, 0) 20%);
          background-position: right;
          background-size: 1px 9px;
          background-repeat: repeat-y;
          padding-top: 7px;
        `;
      } else if (columnIndex == 12 || columnIndex == 13) {
        return "padding: 7px 6px;";
      } else {
        return "padding-top: 7px;";
      }
      // if (columnIndex == 2) {
      //   if (rowIndex == 0) {
      //     return "font-size: 16px; padding-top: 12px;";
      //   } else {
      //     return "font-size: 16px;";
      //   }
      // } else if (columnIndex > 6 && columnIndex < 12) {
      //   if (rowIndex == 0) {
      //     if (columnIndex == 7) {
      //       return "background-color: #F2F2F2; border-top-left-radius: 10px; padding-top: 12px;";
      //     } else if (columnIndex == 11) {
      //       return "background-color: #F2F2F2; border-top-right-radius: 10px; padding-top: 12px;";
      //     } else {
      //       return "background-color: #F2F2F2; padding-top: 12px;";
      //     }
      //   } else {
      //     return "background-color: #F2F2F2;";
      //   }
      // } else {
      //   if (rowIndex == 0) {
      //     return "padding-top: 12px;";
      //   }
      // }
    },
    getImgUrl(pic) {
      var images = require.context("../../assets/images/", false, /\.png$/);
      return images("./" + pic + ".png");
    },
    truncateText(text, maxLength) {
      let length = maxLength;
      return text.length > length ? text.slice(0, length) + "..." : text;
    },
    findTeamNameByKey(key) {
      if (key && this.optionsTeam) {
        for (let i = 0; i < this.optionsTeam.length; i++) {
          if (key === this.optionsTeam[i].key) {
            return this.optionsTeam[i].name;
          }
        }
      } else {
        return "";
      }
    },
    async exportChart(table) {
      if (table == "modal") {
        this.$store.dispatch("teams/getDataGraphExport", {
          table: table,
          activeWhere: this.activeWhere,
          filter: this.selectModalMonth,
          labeldate: this.newLabelsModalfulldate,
        });
      } else {
        this.$store.dispatch("teams/getDataGraphExport", {
          table: table,
          activeWhere: this.activeWhere,
          filter: this.selectMainPageMonth,
          labeldate: this.newLabelsfulldate,
        });
      }
    },
    compare(a, b) {
      let sortingBy = "happirate";
      let sortType = "asce"; // lowest
      if (a && b) {
        if (this.selectMainPageSort == "3") {
          sortingBy = "riskrate";
          sortType = "desc";
        } else if (this.selectMainPageSort == "2") {
          sortingBy = "riskrate";
          sortType = "asce";
        } else if (this.selectMainPageSort == "1") {
          sortingBy = "happirate";
          sortType = "desc";
        } else {
          sortingBy = "happirate";
          sortType = "asce";
        }
        const sortA = a[sortingBy];
        const sortB = b[sortingBy];

        let comparison = 0;
        if (sortA > sortB) {
          comparison = 1;
        } else if (sortA < sortB) {
          comparison = -1;
        }
        if (sortType === "desc") {
          comparison = comparison * -1;
        }
        return comparison;
      } else {
        return undefined;
      }
    },
    compareModal(a, b) {
      let sortingBy = "happirate";
      let sortType = "asce"; // lowest
      if (a && b) {
        if (this.selectModalSort == "3") {
          sortingBy = "riskrate";
          sortType = "desc";
        } else if (this.selectModalSort == "2") {
          sortingBy = "riskrate";
          sortType = "asce";
        } else if (this.selectModalSort == "1") {
          sortingBy = "happirate";
          sortType = "desc";
        } else {
          sortingBy = "happirate";
          sortType = "asce";
        }
        const sortA = a[sortingBy];
        const sortB = b[sortingBy];

        let comparison = 0;
        if (sortA > sortB) {
          comparison = 1;
        } else if (sortA < sortB) {
          comparison = -1;
        }
        if (sortType === "desc") {
          comparison = comparison * -1;
        }
        return comparison;
      } else {
        return undefined;
      }
    },
    deleteChild() {
      const objCount = Array.isArray(this.realDataMainTreeTable)
        ? this.realDataMainTreeTable.length
        : Object.keys(this.realDataMainTreeTable || {}).length;
      const rootRow = Array.isArray(this.realDataMainTreeTable)
        ? this.realDataMainTreeTable[0]
        : null;

      if (
        objCount === 1 &&
        rootRow &&
        rootRow.child_num > 0 &&
        Array.isArray(rootRow.children)
      ) {
        rootRow.children = rootRow.children.sort(this.compare);
        for (
          let i = 0;
          i < rootRow.children.length;
          i++
        ) {
          if (
            Array.isArray(rootRow.children[i].children) &&
            rootRow.children[i].children.length > 0
          ) {
            delete rootRow.children[i].children;
            rootRow.children[i].hasChildren = true;
          }
        }
      }
    },
    deleteModalChild() {
      const objCount = Array.isArray(this.realDataModalTreeTable)
        ? this.realDataModalTreeTable.length
        : Object.keys(this.realDataModalTreeTable || {}).length;
      const rootRow = Array.isArray(this.realDataModalTreeTable)
        ? this.realDataModalTreeTable[0]
        : null;

      if (
        objCount === 1 &&
        rootRow &&
        rootRow.child_num > 0 &&
        Array.isArray(rootRow.children)
      ) {
        rootRow.children = rootRow.children.sort(this.compareModal);
        for (
          let i = 0;
          i < rootRow.children.length;
          i++
        ) {
          if (
            Array.isArray(rootRow.children[i].children) &&
            rootRow.children[i].children.length > 0
          ) {
            delete rootRow.children[i].children;
            rootRow.children[i].hasChildren = true;
          }
        }
      }
    },
    dataMainTreeTable() {
      let obj = _.cloneDeep(this.dataAllList || []);
      this.realDataMainTreeTable = [];
      this.mainTableDataReady = false;
      this.mainExpandKeys = [];
      const objCount = Array.isArray(obj) ? obj.length : Object.keys(obj).length;

      if (
        objCount === 1 &&
        obj[0] &&
        obj[0].child_num > 0 &&
        Array.isArray(obj[0].children)
      ) {
        obj[0].children = obj[0].children.sort(this.compare);
        this.mainExpandKeys.push(obj[0].id);
      } else if (obj.children) {
        delete this.realDataMainTreeTable.children;
        obj.children = obj.children.sort(this.compare);
      }
      this.realDataMainTreeTable = obj;
      this.mainTableDataReady = this.realDataMainTreeTable.length > 0;
      this.deleteChild();
    },
    dataModalTreeTable() {
      let obj = _.cloneDeep(this.dataAllListModal || []);
      this.realDataModalTreeTable = [];
      this.modalTableDataReady = false;
      this.modalExpandKeys = [];
      const objCount = Array.isArray(obj) ? obj.length : Object.keys(obj).length;

      if (
        objCount === 1 &&
        obj[0] &&
        obj[0].child_num > 0 &&
        Array.isArray(obj[0].children)
      ) {
        obj[0].children = obj[0].children.sort(this.compareModal);
        this.modalExpandKeys.push(obj[0].id);
      } else if (obj.children) {
        delete this.realDataModalTreeTable.children;
        obj.children = obj.children.sort(this.compareModal);
      }
      this.realDataModalTreeTable = obj;
      this.modalTableDataReady = this.realDataModalTreeTable.length > 0;
      this.deleteModalChild();
    },
    load(tree, treeNode, resolve) {
      if (Array.isArray(tree.children)) {
        tree.children = tree.children.sort(this.compare);
        resolve(tree.children);
      } else {
        let childrenTeam = _(this.dataAllList)
          .thru(function (coll) {
            return _.union(coll, _.map(coll, "children") || []);
          })
          .flatten()
          .find({ id: tree.id });

        if (childrenTeam && Array.isArray(childrenTeam.children)) {
          for (let i = 0; i < childrenTeam.children.length; i++) {
            if (childrenTeam.children[i].child_num > 0) {
              childrenTeam.children[i].hasChildren = true;
            }
          }
          childrenTeam.children = childrenTeam.children.sort(this.compare);
          return resolve(childrenTeam.children);
        }
        return resolve([]);
      }
    },
    loadModal(tree, treeNode, resolve) {
      if (Array.isArray(tree.children)) {
        tree.children = tree.children.sort(this.compareModal);
        resolve(tree.children);
      } else {
        let childrenTeam = _(this.dataAllListModal)
          .thru(function (coll) {
            return _.union(coll, _.map(coll, "children") || []);
          })
          .flatten()
          .find({ id: tree.id });

        if (childrenTeam && Array.isArray(childrenTeam.children)) {
          for (let i = 0; i < childrenTeam.children.length; i++) {
            if (childrenTeam.children[i].child_num > 0) {
              childrenTeam.children[i].hasChildren = true;
            }
          }
          childrenTeam.children = childrenTeam.children.sort(this.compareModal);
          return resolve(childrenTeam.children);
        }
        return resolve([]);
      }
    },
    renderPhaseHeader(h, { column }) {
      let className = "labelTable rotate";
      return h(
        "div",
        {
          class: className,
        },
        [
          h(
            "div",
            {
              class: "ellipsis left",
              style: "overflow: hidden; width: 110px;",
            },
            column.label
          ),
        ]
      );
    },
    showingHistoryMainTable(value) {
      this.loadingChartInTable = true;
      this.generateChartTooltipOnMain(value);
    },
    showingHistoryModalTable(value) {
      this.loadingChartInTable = true;
      this.generateChartTooltipOnModal(value);
    },
    showingHistoryMainEngagementTable(value) {
      this.hoverTeam = value
      this.$store.dispatch("teams/getTeamEngagementScore", {
        selectTeam: value.id,
      })
    },
    showingHistoryModalEngagementTable(value) {
      this.hoverModalTeam = value
      this.$store.dispatch("teams/getTeamEngagementScoreModal", {
        selectTeam: value.id,
      })
    },
    detectColorTotal(value) {
      if(value == '-'){
        return "gray";
      }else if (value >= 60) {
        return "green";
      } else if (value < 60 && value >= 40) {
        return "yellow";
      } else {
        return "red";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.headerCard {
  display: flex;
  margin-top: 24px;
}
.headerCard2 {
  display: flex;
  margin-top: 36px;
}
.txtHeaderCard {
  font-size: 18px;
  font-weight: 700;
}
.txt-spot-card .txtmenuOption {
  font-size: 16px;
}
.txt-spot-card {
  font-size: 16px;
  font-weight: 700;
}
.menuOptionStyle {
  border-bottom: transparent;
  background: #f4f4f4;
  border-radius: 4px;
}
.txtOption2 {
  color: #4a4a4a;
  font-size: 16px;
  margin-left: 16px;
  width: 140px;
  display: inline-block;
}
.divTable {
  flex: 1;
  margin: 38px 0px 38px 0px;
}
.flexCenter {
  align-items: center;
}
.space-between {
  justify-content: space-between;
}
.divCurcleStatus {
  width: 28px;
  height: 28px;
  text-align: center;
  border-radius: 50%;
  background-color: #C7C7C7;
  // padding: 12px;
}
.divCurcleStatus.yellow{
  background-color: #FBC02D;
}
.divCurcleStatus.green{
  background-color: #66BB6A;
}
.divCurcleStatus.red{
  background-color: #F44336;
}
.divCurcleStatus .scorelabel{
  font-size: 11px;
  font-weight: 700;
  line-height: 28px;
  color: #000000;
  display: none;
}
.el-table__row:hover .divCurcleStatus.green{
  background-color: #66BB6A50;
}
.el-table__row:hover .divCurcleStatus.yellow{
  background-color: #FBC02D50;
}
.el-table__row:hover .divCurcleStatus.red{
  background-color: #F4433650;
}
.el-table__row:hover .scorelabel{
  display: block;
}
.SpotBox {
  margin-top: 16px;
  width: 25%;
  box-sizing: border-box;
}
.SpotGroupBox {
  // height: 47px;
  margin-top: 12px;
  // padding-bottom: 6px;
  box-sizing: border-box;
  overflow: hidden;
  cursor: pointer;
  border-radius: 8px;
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.SpotGroupBox .icon-anim {
  transition: transform 0.3s ease-in-out;
}

.SpotGroupBox:hover .icon-anim {
  transform: translateX(6px);
}
.KeyGroupBox {
  margin-top: 6px;
  margin-right: 6px;
  width: 168px;
  height: 48px;
  border-radius: 8px;
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  // box-shadow: 0px 2px 4px #00000029;
  box-sizing: border-box;
  overflow: hidden;
  cursor: default;
}
.txtHeaderSpot {
  font-size: 14px;
  opacity: 0.92;
  color: #000000;
  font-weight: 500;
  white-space: nowrap;
}
.txtDetailSpot {
  font-size: 11px;
  color: #000000;
  opacity: 0.7;
  white-space: nowrap;
}
.tooltipStyle {
  width: 218px;
}
.noDataTextStyle {
  font-size: 12px;
  color: #939393;
}
.modal-header {
  background-color: #f2f2f2;
  border-radius: 6px 6px 0 0;
  font-size: 20px;
  font-weight: 700;
  color: #4a4a4a;
}
.chart-bar {
  margin-top: 24px;
  background-color: rgba(0,0,0,0.03);
  border-radius: 24px;
  padding: 32px 24px 0;
}
.loading-chart-bar {
  height: 50px;
  margin-top: 72px;
  margin-bottom: 20px;
}
.chart-type-bar {
  width: 20px;
  height: 15px;
  border-radius: 4px;
}
.chart-type-bar.red {
  border: none;
  background: linear-gradient(to top, rgba(244, 67, 54, 0.65), rgba(244, 67, 54, 0.85));
}
.chart-type-bar.green {
  border: none;
  background: linear-gradient(to top, rgba(58, 196, 125, 0.65), rgba(58, 196, 125, 0.85));
}
.chart-type-bar.line {
  border: 1px solid #66bb6a00;
  background-color: #66bb6a00;
  > div {
    height: 2px;
    border-radius: 2px;
    background-color: #6c30cc;
    margin-top: 6px;
  }
}
.type-bar-text {
  color: #000;
  opacity: 0.6;
  font-size: 10px;
  margin: 0 16px 0 6px;
}
.text-open-modal {
  cursor: pointer;
  transition: 0.3s;
  &:hover {
    text-decoration: underline;
  }
}
.chart-legend {
  display: flex;
  padding: 4px 12px;
  border: 1px solid #E8E8E8;
  border-radius: 4px;
  align-items: center;
  margin: 6px 0 0 12px;
}
.chart-legend.first {
  margin: 6px 0 0 0;
}

.chart-legend .symbol {
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin: 0 8px;
}

.symbol.blue {
  background-color: #00ACC1;
}

.symbol.orange {
  background-color: #E45006;
}

.symbol.pink {
  background-color: #D532C2;
}

/* Team Health Overview Styles */
.highlights {
  width: 896px;
  overflow: hidden;
}

.box-card-border {
  box-shadow:
    0px 0.3px 0.9px rgba(0, 0, 0, 0.008),
    0px 0.8px 2.1px rgba(0, 0, 0, 0.012),
    0px 1.5px 4px rgba(0, 0, 0, 0.015),
    0px 2.7px 7.1px rgba(0, 0, 0, 0.018),
    0px 5px 13.4px rgba(0, 0, 0, 0.022),
    0px 12px 32px rgba(0, 0, 0, 0.03);
  border-radius: 4px;
  padding: 24px;
  width: 100%;
}

.grid-5-20 {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.flex-row {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}

.text-skeleton {
  background: #f0f0f0;
  border-radius: 4px;
  height: 24px;
  width: 60px;
  animation: skeleton-loading 1.5s ease-in-out infinite alternate;
}

@keyframes skeleton-loading {
  0% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}

.health-pill-skeleton {
  background: #f0f0f0;
  border-radius: 12px;
  height: 24px;
  width: 80px;
  animation: skeleton-loading 1.5s ease-in-out infinite alternate;
}

/* Health Benchmark Pill Styles */
.health-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-width: 80px;
  text-align: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.health-excellent {
  background-color: rgba(26, 195, 98, 0.15);
  color: #1AC362;
  border: 1px solid rgba(26, 195, 98, 0.3);
}

.health-good {
  background-color: rgba(102, 187, 106, 0.15);
  color: #4CAF50;
  border: 1px solid rgba(102, 187, 106, 0.3);
}

.health-needs-attention {
  background-color: rgba(251, 192, 45, 0.15);
  color: #F57C00;
  border: 1px solid rgba(251, 192, 45, 0.3);
}

.health-critical {
  background-color: rgba(244, 67, 54, 0.15);
  color: #D32F2F;
  border: 1px solid rgba(244, 67, 54, 0.3);
}

.health-no-data {
  background-color: rgba(153, 153, 153, 0.15);
  color: #757575;
  border: 1px solid rgba(153, 153, 153, 0.3);
}

/* Health Progress Bar Styles */
.health-progress-bar {
  width: 100%;
  height: 4px;
  background-color: #E8E8E8;
  border-radius: 2px;
  overflow: hidden;
  margin-top: 2px;
  cursor: pointer;
  transition: height 0.2s ease-in-out, background-color 0.2s ease-in-out;
}

.health-progress-bar:hover {
  height: 6px;
  background-color: #D0D0D0;
}

.health-progress-fill {
  height: 100%;
  border-radius: 2px;
  transition: width 0.3s ease-in-out, box-shadow 0.2s ease-in-out;
}

.health-progress-bar:hover .health-progress-fill {
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
}

.health-progress-skeleton {
  width: 100%;
  height: 4px;
  background: #f0f0f0;
  border-radius: 2px;
  animation: skeleton-loading 1.5s ease-in-out infinite alternate;
  margin-top: 2px;
}

/* Progress Bar Tooltip Styles */
.progress-tooltip {
  background: #1A202C;
  color: #E2E8F0;
  padding: 8px 12px;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  pointer-events: none;
  z-index: 1001;
}

/* Health Metric Hover States */
.health-metric-container {
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border-radius: 8px;
  padding: 8px;
  margin: -8px;
}

.health-metric-container:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  background-color: rgba(255, 255, 255, 0.8);
}

/* Tooltip Styles */
.health-tooltip {
  background: #2D3748;
  color: white;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  max-width: 320px;
  font-size: 13px;
  line-height: 1.4;
  pointer-events: none;
}

.tooltip-header {
  font-weight: 700;
  font-size: 14px;
  color: #E2E8F0;
  margin-bottom: 8px;
  border-bottom: 1px solid rgba(226, 232, 240, 0.2);
  padding-bottom: 6px;
}

.tooltip-value {
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 8px;
  color: #68D391;
}

.tooltip-description {
  color: #CBD5E0;
  margin-bottom: 8px;
}

.tooltip-trend {
  color: #90CDF4;
  font-size: 12px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(226, 232, 240, 0.2);
}

</style>
<style lang="scss">
#insightsTeam > div > div.headerCard > div.showOption > ul > li > div {
  height: 40px !important;
  line-height: 40px !important;
}
#insightsTeam > div > div.headerCard2 > div.showOption > ul > li > div {
  height: 40px !important;
  line-height: 40px !important;
}
#teamsTable.el-table td {
  border-bottom: 0px solid #e6e5e4 !important;
}
#teamsTable.el-table--enable-row-hover
  .el-table__body
  tr:hover
  > td.el-table__cell {
  background-color: transparent;
}
// #teamsTable.el-table
//   .el-table__body
//   tr:last-child
//   > td.el-table__cell:nth-last-child(2) {
//   border-bottom-right-radius: 10px;
// }
// #teamsTable.el-table
//   .el-table__body
//   tr:last-child
//   > td.el-table__cell:nth-last-child(6) {
//   border-bottom-left-radius: 10px;
// }
#teamsTable .th {
  .labelTable div {
    overflow: visible;
  }
  .rotate {
    -webkit-transform: 
  /* Magic Numbers */ rotate(320deg);
    transform: 
  /* Magic Numbers */ rotate(320deg);
    width: 60px;
  }
}
#teamsTable
  > div.el-table__header-wrapper
  > table
  > thead
  > tr
  > .labelTable.is-leaf {
  padding: 40px 0 20px;
  overflow: unset;
  position: unset;
  > div {
    overflow: unset;
    position: unset;
    width: 100%;
    position: relative;
    display: inline-block;
    box-sizing: border-box;
    vertical-align: middle;
    padding-left: 0px;
    padding-right: 0px;
    .rotate {
      position: unset;
      transform: rotate(315deg);
      width: 45px;
      .left {
        overflow: hidden;
        width: 110px;
        font-size: 12px;
      }
    }
  }
}
#teamsTable
  > div.el-table__header-wrapper
  > table
  > thead
  > tr
  > .labelRateTable.is-leaf {
  > div {
    font-size: 12px;
    line-height: 15px;
  }
  div.word-break {
    word-break: normal;
  }
}
#teamsTable
  > div.el-table__header-wrapper
  > table
  > thead
  > tr
  > .labelRateTable-spam.is-leaf {
  > div {
    font-size: 12px;
    line-height: 15px;
    padding-left: 6px;
    padding-right: 6px;
  }
  div.word-break {
    word-break: normal;
  }
}
#teamsTable
  > div.el-table__header-wrapper
  > table
  > thead
  > tr
  > .labelTeamTable.is-leaf
  > div {
  font-size: 16px;
  width: 325px;
}

#teamsTable
  > div.el-table__body-wrapper.is-scrolling-none
  > table
  > tbody
  > tr
  > td.tag
  > div {
  padding: 0;
  margin-left: auto;
}
#teamsTable
  > div.el-table__body-wrapper.is-scrolling-none
  > table
  > tbody
  > tr
  > td
  > div {
  color: #000;
  font-weight: 400;
  word-break: unset;
}
#teamsTable .el-table__expand-icon {
  color: #000;
}
#teamsTable .el-table__expanded-cell[class*="cell"] {
  padding: unset;
}
#teamsTable
  > div.el-table__header-wrapper
  > table
  > thead
  > tr
  > th.line-break
  > div {
  word-break: unset;
}
// #teamsTable
//   > div.el-table__header-wrapper
//   > table
//   > thead
//   > tr
//   > th.line-break
//   > div {
//   word-break: unset;
//   color: red;
// }
#teamsTable.el-table th {
  border: 0;
  padding: 12px 0px 0px 0px;
  background-color: transparent;
}
#teamsTable.el-table td {
  padding: 0px 0px 7px 0px;
  transition: 0.3s;
  &:first-of-type {
    border-radius: 6px 0 0 6px;
  }
  &:last-of-type {
    border-radius: 0 6px 6px 0;
  }
}
#teamsTable.el-table .el-table__body tr {
  transition: 0.3s;
  &:hover {
    background-color: rgba($color: #000000, $alpha: 0.03);
    .text-open-modal {
      text-decoration: underline;
    }
  }
}
#teamModal {
  > .el-dialog__wrapper {
    padding-left: 0px;
  }
  @media only screen and (min-width: 597px) {
    > .el-dialog__wrapper {
      padding-left: 236px;
    }
  }
  @media only screen and (min-width: 1300px) {
    > .el-dialog__wrapper {
      padding-left: 256px;
    }
  }
  .el-dialog {
    width: calc(1024px - 32px);
    border-radius: 6px;
  }
  .el-dialog__header {
    padding: 0px;
  }
  .el-dialog__body {
    padding: 0;
    color: #000;
  }
  .el-dialog__headerbtn {
    top: 10px;
  }
  .el-submenu > .el-submenu__title {
    height: 40px !important;
    line-height: 40px !important;
  }

  .dimension-trends-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
  }
  .dimension-trend-card {
    padding: 14px 16px 12px;
    border: 1px solid #E8E8E8;
    border-radius: 10px;
    background: #FAFAFA;
    min-height: 100px;
  }
  .dimension-trend-header {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  }
  .trend-dots-row {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .trend-dot {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background-color: #C7C7C7;
    flex-shrink: 0;
  }
  .trend-dot.green { background-color: #66BB6A; }
  .trend-dot.yellow { background-color: #FBC02D; }
  .trend-dot.red { background-color: #F44336; }
  .dimension-trend-score { color: #C7C7C7; }
  .dimension-trend-score.green { color: #4CAF50; }
  .dimension-trend-score.yellow { color: #F9A825; }
  .dimension-trend-score.red { color: #E53935; }

  /* Skeleton loading */
  .skeleton-pulse {
    animation: skeleton-pulse 1.5s ease-in-out infinite;
  }
  @keyframes skeleton-pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.4; }
  }
  .skeleton-line {
    background: #E0E0E0;
    border-radius: 4px;
  }
  .skeleton-dot {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #E0E0E0;
  }

}
</style>
